<template>
  <div class="mindmap-htwb">
    <q-dialog v-model="showImgEditor" id="mindmap-img-editor" persistent>
      <mind-map-img-editor />
    </q-dialog>

    <!-- <div class="mindmap-tool mindmap-tool-upload" v-show="isTool&&isUploadSharing">
      <div @click="uploadToSharing()" class="controls"><svg-icon iconClass="upload" /></div>
    </div> -->


    <!-- <div v-show="showShareLinkBox" class="shareCard-wrap">
      <div class="shareCard">
        <div class="close-btn"><svg-icon iconClass="close" @click="closeShareLinkBox()"></svg-icon></div>
        <div class="shareCard-title">{{ currentMindMap.mindmapName }}</div>

        <div v-show="currentMindMap.openCowork" class="url-wrap"><span class="url-title">URL：</span>{{ shortURLHost }}<span class="short-url">{{
      currentMindMapURL }}</span>
      <span class="copy-btn" @click="copyShortUrl()"><svg-icon icon-class="copy" /></span>    
    </div>
        <div class="cowork-mode">
          <div class="cowork-mode-title">{{ $t("mindmap.mindmapHome.haveLinkCanDo") }}</div>
          <SelectMenu :category="coworkModeCate" :defaultSelect="'edit'" ref="coworkModeSelect"
            class="cowork-mode-select" />
          <div v-show="currentMindMap.openCowork && showSaveCoworkBtn" class="save-btn" @click="saveCoworkMode()">
            {{ $t("mindmap.mindmapHome.save") }}
          </div>
          
        </div>
      </div>
    </div> -->

    <!-- 心智圖類型選擇表單 -->
    <div v-show="isAskJumpSharing" class="mindmap-type-overlay">
      <div class="mindmap-type-selection">
        <div class="mindmap-type-title">{{ $t('mindmap.mindmapTypeSelection.title') }}</div>
        
        <div class="mindmap-type-buttons">
          <div 
            class="mindmap-type-btn local-btn"
            @click="selectLocalMindMap()"
          >
            {{ $t('mindmap.mindmapTypeSelection.localMindmap') }}
          </div>
          
          <div 
            class="mindmap-type-btn cloud-btn"
            @click="confirmJumpSharing()"
          >
            {{ $t('mindmap.mindmapTypeSelection.cloudMindmap') }}
          </div>
        </div>
      </div>
    </div>


    <ImgViewer :currentImg="currentImgUrl" v-if="showImgViewer" />
    <!--節點歷史UI-->
    <div class="node-history-wrap" v-show="showNodeHistory">
      <div class="node-history-card">
        <div class="close-btn" @click="showNodeHistory = false">
          <svg-icon icon-class="close" class="close-icon" />
        </div>
        <div class="node-history-title">{{ $t('webirs.mindmap.nodeHistory.節點歷史') }}</div>
        <div class="node-history-scroll-area">
          <table class="node-history-table">
            <thead>
              <tr>
                <th>{{ $t('webirs.mindmap.nodeHistory.動作') }}</th>
                <th>{{ $t('webirs.mindmap.nodeHistory.編輯者') }}</th>
                <th>{{ $t('webirs.mindmap.nodeHistory.內容') }}</th>
                <th>{{ $t('webirs.mindmap.nodeHistory.線條顏色') }}</th>
                <th>{{ $t('webirs.mindmap.nodeHistory.節點顏色') }}</th>
                <th>{{ $t('webirs.mindmap.nodeHistory.註解') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in currentNodeHistory" :key="item + index">
                <td><span v-show="item.action == 'add' || item.action == 'update'">{{
                    $t(`webirs.mindmap.nodeHistory['${item.action}']`) }}</span></td>
                <td>{{ item.fromInfo.seat == 'wb' ? "" : item.fromInfo.seat }}{{ item.fromInfo.name }}</td>
                <td>
                  <div v-html="item.nodeContent"></div>
                </td>
                <td>
                  <div class="color-line"
                    :style="{ 'background-color': item.lineColor ? item.lineColor : 'transparent' }">
                  </div>
                </td>
                <td>
                  <div class="color-ball"
                    :style="{ 'background-color': item['background-color'] ? item['background-color'] : 'transparent' }">
                  </div>
                </td>
                <td>{{ item.note ? item.note : "" }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!--重播UI，同Konva-->
    <div v-if="isCoworkReplay" class="replay-ui">
      <div class="slider_box">
        <p class="flashing-text" v-show="!isPauseReplay">{{ $t('webirs.konvaCanvas.回放中') }}</p>
        <p class="pause-text" v-show="isPauseReplay">{{ $t('webirs.konvaCanvas.暫停') }}</p>
        <span class="slider-text">{{ $t('webirs.konvaCanvas.標準') }}</span>
        <div class="custom-switch" @click="toggleReplayMode">
          <div class="switch-track" :class="{ active: replayFastMode }">
            <div class="switch-thumb"></div>
          </div>
        </div>
        <span class="slider-text">{{ $t('webirs.konvaCanvas.快速') }}</span>
        <div class="controls" @click="pauseReplay()" v-show="!isPauseReplay">
          <svg-icon iconClass="pause" class="pause-icon" />
        </div>
        <div class="controls" @click="continueReplay()" v-show="isPauseReplay">
          <svg-icon iconClass="play" class="continue-icon" />
        </div>
      </div>
    </div>
    <div class="addnode-wrap" v-show="showAddNoteTool">
      <div class="addnode-card-md">
        <p class="addnode-title-large">{{ ctrlNodeMode == "add" ? $t('webirs.mindmap.新增') : $t('webirs.mindmap.編輯') }}
        </p>
        <div class="card-scroll-area">

          <input id='node-text-focus' class="addnode-text small-textarea" v-model="nodeText"
            :placeholder="$t('webirs.mindmap.輸入文字')" maxlength="40" />
          <p class="text-length">{{ nodeTextLength }}/40 </p>
          <div class="addnode-direction" v-if="isCurrentSelectRoot">
            <div class="addnode-title">{{ $t('webirs.mindmap.加入根節點') }}</div>
            <label class="radio-btn" :class="{ 'check-btn': direction === 'left' }"><input type="radio"
                v-model="direction" value="left">{{ $t('webirs.mindmap.左邊') }}</label>
            <label class="radio-btn" :class="{ 'check-btn': direction === 'right' }"><input type="radio"
                v-model="direction" value="right">{{ $t('webirs.mindmap.右邊') }}</label>
          </div>

          <div class="addnode-title more-setting-btn" @click="showMoreSetting = !showMoreSetting">{{
            $t('webirs.mindmap.進階設定') }}&nbsp;<svg-icon iconClass="arrowdown"
              :class="{ 'arrowdown-rotate': showMoreSetting }" /></div>
          <div class="more-setting" v-show="showMoreSetting">
            <div class="divide-wrap">
              <div class="divide-line" />
            </div>
            <!--色彩編輯-->
            <p class="addnode-title" style="padding-top:10px">{{ $t('webirs.mindmap.線條顏色') }}</p>
            <div class="q-gutter-sm" style="padding:10px 0 2px 0;">
              <div class="color-btn" :class="{ 'select-color': currentLineColor == item }"
                :style="{ 'background-color': item }" v-for="(item, index) in lineColorArr" :key="item"
                v-show="index < 5" @click="setLineColor(item)"><svg-icon class='color-check'
                  v-show="currentLineColor == item" icon-class="check" /></div>
            </div>
            <div class="q-gutter-sm" style="padding:2px 0;">
              <div class="color-btn" :class="{ 'select-color': currentLineColor == item }"
                :style="{ 'background-color': item }" v-for="(item, index) in lineColorArr" :key="item"
                v-show="index >= 5" @click="setLineColor(item)"><svg-icon class='color-check color-check-white'
                  v-show="currentLineColor == item" icon-class="check" /></div>
            </div>

            <p class="addnode-title" style="margin-top:5px">{{ $t('webirs.mindmap.節點顏色') }}</p>
            <div class="q-gutter-sm" style="padding:10px 0 2px 0;">
              <div class="color-btn" :class="{ 'select-color': currentNodeColor == item }"
                :style="{ 'background-color': item }" v-show="index < 4" v-for="(item, index) in nodeColorArr"
                :key="index + 'sticker'" @click="setNodeColor(item)"><svg-icon class='color-check'
                  v-show="currentNodeColor == item" icon-class="check" /></div>
            </div>
            <div class="divide-wrap">
              <div class="divide-line" />
            </div>
            <!--圖片編輯非預編-->
            <div>
              <div class="addnode-title">{{ $t('webirs.mindmap.圖片') }}</div>
              <div class="btn-group-init">
                <label class="btn" v-show="currentImgUrl == ''">
                  <svg-icon icon-class="add_imgbgc2" class="draw-icon img_upload-icon" />
                  <input ref="mainImageUploaderInit" type="file" accept="image/JPEG,image/png"
                    @change="imgfileChangeHandler" @click="resetImageUploader" name="img-upload"
                    class="img-upload-input" />
                </label>
                <div class="btn" v-show="currentImgUrl == ''" @click="openWhiteEditor()">
                  <svg-icon icon-class="draw-initial" class="draw-icon draw-icon-small" />
                </div>
              </div>
              <p v-show="isOverMaxImageSize" class="warning-text">{{
                $t('webirs.mindmap.圖片過大提示字1') }}&nbsp;{{ `${maxImageSize}${$t('webirs.mindmap.圖片過大提示字2')}` }}</p>
              <div class="uploader-wrap" v-show="currentImgUrl != ''">
                <div class="uploader">
                  <img class="uploader-img" :src="currentImgUrl" alt="" @click="openEditor()">
                </div>
              </div>
            </div>
            <div class="btn-group-under" v-show="currentImgUrl != ''">
              <label class="btn">
                <svg-icon icon-class="add_imgbgc2" class="img_upload-icon" />
                <input ref="mainImageUploader" type="file" accept="image/JPEG,image/png" @change="imgfileChangeHandler"
                  @click="resetImageUploader" name="img-upload" class="img-upload-input" />
              </label>
              <div class="btn btn-canvas" v-show="currentImgUrl != ''" @click="openWhiteEditor()">
                <svg-icon icon-class="draw-initial" class="draw-icon draw-icon-small" />
              </div>
              <div class="btn btn-close" @click="currentImgUrl = ''">
                <svg-icon icon-class="close" class="close-icon" />
              </div>
            </div>
            <div class="divide-wrap">
              <div class="divide-line" />
            </div>

            <!--連結編輯-->
            <div>
              <div class="addnode-title">{{ $t('webirs.mindmap.連結') }}</div>
              <textarea class="addnode-text small-textarea" v-model="nodeTextURL"
                :placeholder="$t('webirs.mindmap.輸入URL')"></textarea>
            </div>
            <div class="divide-wrap">
              <div class="divide-line" />
            </div>
            <!--註解編輯-->
            <div>
              <div class="addnode-title">{{ $t('webirs.mindmap.註解') }}</div>
              <textarea class="addnode-text" v-model="nodeTextNote" :placeholder="$t('webirs.mindmap.輸入文字')"
                maxlength="100"></textarea>
              <p class="text-length">{{ nodeTextNoteLength }}/100 </p>
            </div>
          </div>
        </div>
        <div class="addnodebtn-area" v-show="!isUploadImg">
          <div class='addnode-warning' v-show="ctrlNodeMode == 'edit' && !isCurrentNodePreEditByMe && !isTool">{{
            $t('webirs.mindmap.preEditHint') + "\n" + nodeEditBy.name + "\n" + $t('webirs.mindmap.confirmUpdate') }}
          </div>
          <div class="addnodebtn-group">
            <div class="addnode-btn" @click="confirm()">{{ $t('webirs.mindmap["確定"]') }}</div>
            <div class="addnode-btn" @click="showAddNoteTool = false">{{ $t('webirs.mindmap["取消"]') }}</div>
          </div>
        </div>

      </div>
      <div class="addnode-card-lg">
        <p class="addnode-title-large">{{ ctrlNodeMode == "add" ? $t('webirs.mindmap.新增') : $t('webirs.mindmap.編輯') }}
        </p>
        <div class="card-scroll-area">

          <input id='node-text-focus-large' class="addnode-text small-textarea" v-model="nodeText"
            :placeholder="$t('webirs.mindmap.輸入文字')" maxlength="40" />
          <p class="text-length">{{ nodeTextLength }}/40 </p>

          <div class="addnode-direction" v-if="isCurrentSelectRoot">
            <div class="addnode-title">{{ $t('webirs.mindmap.加入根節點') }}</div>
            <label class="radio-btn" :class="{ 'check-btn': direction === 'left' }"><input type="radio"
                v-model="direction" value="left">{{ $t('webirs.mindmap.左邊') }}</label>
            <label class="radio-btn" :class="{ 'check-btn': direction === 'right' }"><input type="radio"
                v-model="direction" value="right">{{ $t('webirs.mindmap.右邊') }}</label>
          </div>
          <div class="addnode-title more-setting-btn" @click="showMoreSetting = !showMoreSetting">{{
            $t('webirs.mindmap.進階設定') }}&nbsp;<svg-icon iconClass="arrowdown"
              :class="{ 'arrowdown-rotate': showMoreSetting }" /></div>
          <div class="divide-wrap" v-show="showMoreSetting">
            <div class="divide-line" />
          </div>
          <div class="flex-wrap" v-show="showMoreSetting">

            <div class="left-part">
              <div class="img-area">
                <div class="addnode-title">{{ $t('webirs.mindmap.圖片') }}</div>
                <div class="btn-group-init">
                  <label class="btn btn-upload" v-show="currentImgUrl == ''">
                    <svg-icon icon-class="add_imgbgc2" class="draw-icon img_upload-icon" />
                    <input ref="mainImageUploaderInit" type="file" accept="image/JPEG,image/png"
                      @change="imgfileChangeHandler" @click="resetImageUploader" name="img-upload"
                      class="img-upload-input" />
                  </label>
                  <div class="btn btn-canvas" v-show="currentImgUrl == ''" @click="openWhiteEditor()">
                    <svg-icon icon-class="draw-initial" class="draw-icon draw-icon-small" />
                  </div>
                </div>
                <p v-show="isOverMaxImageSize" class="warning-text">{{
                  $t('webirs.mindmap.圖片過大提示字1') }}&nbsp;{{ `${maxImageSize}${$t('webirs.mindmap.圖片過大提示字2')}` }}</p>
                <div class="uploader-wrap" v-show="currentImgUrl != ''">
                  <div class="uploader">
                    <img class="uploader-img" :src="currentImgUrl" alt="" @click="openEditor()">
                  </div>
                </div>
                <div class="btn-group-under" v-show="currentImgUrl != ''">
                  <label class="btn">
                    <svg-icon icon-class="add_imgbgc2" class="img_upload-icon" />
                    <input ref="mainImageUploader" type="file" accept="image/JPEG,image/png"
                      @change="imgfileChangeHandler" @click="resetImageUploader" name="img-upload"
                      class="img-upload-input" />
                  </label>
                  <div class="btn btn-canvas" v-show="currentImgUrl != ''" @click="openWhiteEditor()">
                    <svg-icon icon-class="draw-initial" class="draw-icon draw-icon-small" />
                  </div>
                  <div class="btn btn-close" @click="currentImgUrl = ''">
                    <svg-icon icon-class="close" class="close-icon" />
                  </div>
                </div>

              </div>
              <div class="divide-wrap">
                <div class="divide-line" />
              </div>
              <div class="addnode-title">{{ $t('webirs.mindmap.連結') }}</div>
              <textarea class="addnode-text small-textarea" v-model="nodeTextURL"
                :placeholder="$t('webirs.mindmap.輸入URL')"></textarea>

            </div>
            <div class="right-part">
              <!--色彩編輯-->
              <p class="addnode-title" style="padding-top:10px">{{ $t('webirs.mindmap.線條顏色') }}</p>
              <div class="q-gutter-sm" style="padding:10px 0 2px 0;">
                <div class="color-btn" :class="{ 'select-color': currentLineColor == item }"
                  :style="{ 'background-color': item }" v-for="(item, index) in lineColorArr" :key="item"
                  v-show="index < 5" @click="setLineColor(item)"><svg-icon class='color-check'
                    v-show="currentLineColor == item" icon-class="check" /></div>
              </div>
              <div class="q-gutter-sm" style="padding:2px 0;">
                <div class="color-btn" :class="{ 'select-color': currentLineColor == item }"
                  :style="{ 'background-color': item }" v-for="(item, index) in lineColorArr" :key="item"
                  v-show="index >= 5" @click="setLineColor(item)"><svg-icon class='color-check color-check-white'
                    v-show="currentLineColor == item" icon-class="check" /></div>
              </div>

              <p class="addnode-title" style="margin-top:5px">{{ $t('webirs.mindmap.節點顏色') }}</p>
              <div class="q-gutter-sm" style="padding:10px 0 2px 0;">
                <div class="color-btn" :class="{ 'select-color': currentNodeColor == item }"
                  :style="{ 'background-color': item }" v-show="index < 4" v-for="(item, index) in nodeColorArr"
                  :key="index + 'sticker'" @click="setNodeColor(item)"><svg-icon class='color-check'
                    v-show="currentNodeColor == item" icon-class="check" /></div>
              </div>
              <div class="divide-wrap">
                <div class="divide-line" />
              </div>


              <div class="addnode-title">{{ $t('webirs.mindmap.註解') }}</div>
              <textarea class="addnode-text" v-model="nodeTextNote" :placeholder="$t('webirs.mindmap.輸入文字')"
                maxlength="100"></textarea>
              <p class="text-length">{{ nodeTextNoteLength }}/100 </p>

            </div>
          </div>
        </div>
        <div class="addnodebtn-area" v-show="!isUploadImg">
          <div class='addnode-warning' v-show="ctrlNodeMode == 'edit' && !isCurrentNodePreEditByMe && !isTool">{{
            $t('webirs.mindmap.preEditHint') + "\n" + nodeEditBy.name + "\n" + $t('webirs.mindmap.confirmUpdate') }}
          </div>
          <div class="addnodebtn-group">
            <div class="addnode-btn" @click="confirm()">{{ $t('webirs.mindmap["確定"]') }}</div>
            <div class="addnode-btn" @click="showAddNoteTool = false">{{ $t('webirs.mindmap["取消"]') }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="addnode-wrap" v-show="showMoveTool">

      <div class="movetool-card">
        <p class="addnode-title-large">{{ $t('webirs.mindmap.moveNodeTitle') }}</p>
        <p class="addnode-title-md">{{ $t('webirs.mindmap.moveNodeHint') }}</p>
        <div class="card-scroll-area" id="movetool-scroll-area">
          <svg class="connections" xmlns="http://www.w3.org/2000/svg" :style="{ height: drawLineAreaH }">
            <!-- 垂直線 -->
            <line v-for="(line, index) in verticalLines" :key="'v-' + index" :x1="line.x1" :y1="line.y1" :x2="line.x2"
              :y2="line.y2" stroke="gray" stroke-width="2" />
            <!-- 水平線 -->
            <line v-for="(line, index) in horizontalLines" :key="'h-' + index" :x1="line.x1" :y1="line.y1" :x2="line.x2"
              :y2="line.y2" stroke="gray" stroke-width="2" />

          </svg>
          <mind-map-tree-menu v-if="treeMenuData != ''" :treeMenuData="treeMenuData" :currentNode="currentNode"
            :currentMoveTargetNode="currentMoveTargetNode" :depth="0"></mind-map-tree-menu>
        </div>
        <div class="addnodebtn-area">
          <div class="addnodebtn-group">
            <div class="addnode-btn" @click="confirmMoveToParent()">{{ $t('webirs.mindmap["確定"]') }}</div>
            <div class="addnode-btn" @click="closeMoveTool()">{{ $t('webirs.mindmap["取消"]') }}</div>
          </div>
        </div>
      </div>
    </div>

    <!--mindMap 工具按鈕(注音只有繁中會顯示)-->
    <div class="mindmap-tools-group" v-show="!isCoworkReplay">
       <!-- 注音開關 -->
       <div class="mindmap-tool mindmap-tool-phonetic" v-show="isZHTW">
        <div class="scale-switch-click-area"></div>
        <label class="mindmap-switch">
          <span class="mindmap-switch-title">注音</span>
          <input id="phonetic" type="checkbox" v-model="isPhonetic" />
          <span class="mindmap-slider round"></span>
        </label>
      </div>

      <!-- 分享按鈕 -->
      <div class="mindmap-tool" v-show="isTool && isUploadSharing">
        <div class="share-btn" @click="createInSharing()"><svg-icon iconClass="upload-cloud" class="link-icon" />{{
      $t("webirs.mindmap.share") }}</div>
      </div>
     
      <!-- relayout 按鈕 -->
      <div class="mindmap-tool">
        <div @click="relayout()" class="controls"><svg-icon iconClass="refresh" class="refresh-icon" /></div>
      </div>

    </div>
    <!-- <div class="mindmap-tool" v-show="showAllTool && !isCoworkReplay">
      <div @click="openNode('add')" class="controls"><svg-icon iconClass="add" class="add-icon" /></div>
      <div @click="deleteSelectNode()" class="controls" v-show="!isCurrentSelectRoot"><svg-icon iconClass="minus-pure"
          class="minus-icon" /></div>
      <div @click="copyNode()" class="controls" v-show="!isCurrentSelectRoot"><svg-icon iconClass="copy2"
          class="copy-icon" /></div>
      <div @click="moveNode('up')" class="controls" v-show="!isCurrentSelectRoot"><svg-icon iconClass="arrowdown"
          class="moveup-icon" /></div>
      <div @click="moveNode('down')" class="controls" v-show="!isCurrentSelectRoot"><svg-icon iconClass="arrowdown"
          class="movedown-icon" /></div>
      <div @click="openNode('edit')" class="controls"><svg-icon iconClass="pencil-alt" /></div>
    </div> -->
    <div class="mindmap-menu" :style="{ top: posY + 'px', left: posX + 'px' }" v-show="showNodeMenu">
      <div class="menu-item" @click="openNode('add')" v-show="!readOnlyMode">
        <span class="menu-icon-wrap"><svg-icon iconClass="add" class="add-icon" /></span>{{ $t('webirs.mindmap.menu.新增')
        }}
      </div>
      <div class="menu-item" @click="deleteSelectNode()"
        v-show="!isCurrentSelectRoot && isCurrentNodeCanBeDelete && !readOnlyMode && !isCurrentNodeLock">
        <span class="menu-icon-wrap"><svg-icon iconClass="minus-pure" class="minus-icon" /></span>{{
        $t('webirs.mindmap.menu.刪除') }}
      </div>
      <div class="menu-item" @click="moveNode('up')"
        v-show="!isCurrentSelectRoot && isCurrentNodeCanMoveUp && !readOnlyMode">
        <span class="menu-icon-wrap"><svg-icon iconClass="arrowdown" class="moveup-icon" /></span>{{
        $t('webirs.mindmap.menu.上移') }}
      </div>
      <div class="menu-item" @click="moveNode('down')"
        v-show="!isCurrentSelectRoot && isCurrentNodeCanMoveDown && !readOnlyMode">
        <span class="menu-icon-wrap"><svg-icon iconClass="arrowdown" class="movedown-icon" /></span>{{
        $t('webirs.mindmap.menu.下移') }}
      </div>
      <div class="menu-item" @click="moveNode('left')" v-show="isCurrentNodeCanMoveRight">

        <span class="menu-icon-wrap"><svg-icon iconClass="arrowdown" class="moveleft-icon" /></span>{{
        $t("webirs.mindmap.menu.左移") }}
      </div>
      <div class="menu-item" @click="moveNode('right')" v-show="isCurrentNodeCanMoveLeft">

        <span class="menu-icon-wrap"><svg-icon iconClass="arrowdown" class="moveright-icon" /></span>{{
        $t("webirs.mindmap.menu.右移") }}
      </div>

      <div class="menu-item" @click="openMoveTool()"
        v-show="!isCurrentSelectRoot && !readOnlyMode && !isCurrentNodeLock && isTool || !isCurrentSelectRoot && !readOnlyMode && !isCurrentNodeLock && !isTool">
        <span class="menu-icon-wrap"><svg-icon iconClass="moveTo" class="minus-icon" /></span>{{
        $t('webirs.mindmap.menu.move') }}
      </div>
      <div class="menu-item" @click="openNode('edit')" v-show="!readOnlyMode && !isCurrentNodeLock"> <span
          class="menu-icon-wrap"><svg-icon iconClass="pencil-alt" class="pencil-icon" /></span>{{
        $t('webirs.mindmap.menu.編輯') }}</div>
      <div class="menu-item" @click="copyNode()" v-show="!isCurrentSelectRoot && !readOnlyMode"> <span
          class="menu-icon-wrap"><svg-icon iconClass="copy2" class="copy-icon" /></span>{{ $t('webirs.mindmap.menu.複製')
        }}</div>

      <div class="menu-item" @click="toggleNodeLock()" :class="{ 'lock-color': isCurrentNodeLock }"
        v-show="!readOnlyMode">
        <span class="menu-icon-wrap"><svg-icon :iconClass="isCurrentNodeLock ? 'lock' : 'unlock'"
            :class="isCurrentNodeLock ? 'lock-icon' : 'unlock-icon'" /></span>{{ isCurrentNodeLock ?
        $t('webirs.mindmap.menu.unlock') : $t('webirs.mindmap.menu.lock') }}
      </div>

      <div class="menu-item" @click="applyNodeColor()" v-show="!readOnlyMode && !isCurrentSelectRoot && isCurrentNodeHasChildren && isTool">
        <span class="menu-icon-wrap"><svg-icon iconClass="apply_color" class="text-color apply-color-icon" /></span>{{
        $t('webirs.mindmap.menu.applyColor') }}
      </div>

      <div class="menu-item" @click="applyAllRightLayout()" v-show="!readOnlyMode && isCurrentSelectRoot && isTool">
        <span class="menu-icon-wrap"><svg-icon iconClass="all_right-side" class="all-right-icon" /></span>{{
        $t('webirs.mindmap.menu.allRightLayout') }}
      </div>
      <div class="menu-item" @click="applyAllLeftLayout()" v-show="!readOnlyMode && isCurrentSelectRoot && isTool">
        <span class="menu-icon-wrap"><svg-icon iconClass="all_left-side" class="all-left-icon" /></span>{{
        $t('webirs.mindmap.menu.allLeftLayout') }}
      </div>

      <div class="menu-item" v-if="showViewNodeHistoryMenuItem" @click="viewNodeHistory()">
        <span class="menu-icon-wrap"><svg-icon iconClass="historyClock" class="history-icon" /></span>{{
        $t('webirs.mindmap.menu.檢視節點變更記錄') }}
      </div>
      <div v-show="showSelectedNote" class="divide-wrap">
        <div class="divide-line" />
      </div>
      <div v-show="showSelectedNote" class=" note-wrap">
        <p class="note-text"> {{ nodeTextNote }}</p>
      </div>
      <div class="divide-wrap" v-show="nodeEditBy.id != '' && nodeEditBy.name != ''">
        <div class="divide-line" />
      </div>
      <div class="node-info" v-show="nodeEditBy.id != '' && nodeEditBy.name != ''">
        <span class="dot" />
        <span v-show="nodeEditBy.seat != 'wb'">
          {{ nodeEditBy.seat }}&nbsp;
        </span>{{ nodeEditBy.name }}
      </div>
    </div>
    <div id="jsmind_container" :class="{ 'showPhonetic': isPhonetic }"></div>

  </div>
</template>

<script>
/* eslint-disable */
import { ref, provide, getCurrentInstance, inject, onMounted, onBeforeUnmount, toRaw, nextTick, reactive } from "vue"; //Vue3 composition API
import { QDialog } from "quasar";
import { useQuasar } from "quasar";
import "../api/jsmindlib/jsmind.css";
import * as htmlToImage from 'html-to-image'
import * as jsMind from "../api/jsmindlib/jsmind.js";
import jmNodeIconStr from "../api/jsmindlib/jmNodeIconString.js";
import md from "../api/jsmindlib/mdToJsMind.js";
import ImgViewer from "./ImgViewer.vue";
import SelectMenu from "../components/SelectMenu.vue";
import MindMapImgEditor from './MindMapImgEditor.vue';
import MindMapTreeMenu from "./MindMapTreeMenu.vue";
import SvgIcon from "../components/SvgIcon.vue";
import CryptoJS from "crypto-js";
import iSwitch from 'view-ui-plus'
import jwt_decode from "jwt-decode";
import { useRouter } from "vue-router";


import { SharedMap } from "fluid-framework";
import { AzureClient } from "@fluidframework/azure-client";

import api from "@/api"; //Sharing內的api
import confProfile from "@/api/profile.js";

import enc from '@/api/enc.js'
import { useMindMapStore } from "@/stores/mindMapStore";
const { BlobServiceClient } = require("@azure/storage-blob");
window.jsMind = jsMind;

export default {
  name: "MindMap",
  props: ["isTool"],
  components: {
    ImgViewer, MindMapImgEditor, MindMapTreeMenu, SvgIcon, QDialog, iSwitch, SelectMenu
  },
  setup() {
    let that = getCurrentInstance().proxy;
    const $q = useQuasar();
    const router = useRouter();
    const mindMapStore = useMindMapStore();
    const currentMindMap = ref({});

    const iviewMessage = inject("$Message");
    const containerSchema = reactive({
      initialObjects: {
        mindHistory: SharedMap,
        mindData: SharedMap,
        isDeleting: SharedMap,
        coworkMode: SharedMap,
      },
    });

    let fluidIsDeleting = reactive({});
    let fluidCoworkMode = reactive({}); //fluid 也記錄目前協作模式，擁有者在使用者操作時改變協作模式，須通知其他使用者
    let fluidContainer = reactive({});
    let fluidMindData = reactive({});


    const tokenRefreshInterval = ref(null);

    const initializeAuth = async () => {
      try {
        const res = await api.main.getTokenUnlogin();
        const exp = jwt_decode(res.auth_token).exp;
        localStorage.setItem("auth_token", res.auth_token);
        localStorage.setItem("auth_token_expiry", exp);
      } catch (error) {
        console.error("Error fetching auth token ", error);
      }
    }

    const startTokenRefreshInterval = () => {
      tokenRefreshInterval.value = setInterval(async () => {

        //檢查auth_token是否即將過期
        const authExpiry = localStorage.getItem("auth_token_expiry");
        const now = Date.now();
        const refreshThreshold = 10 * 1000; // 提前 10 秒刷新

        if (authExpiry) {
          const exp = authExpiry * 1000; // 将 exp 转换为毫秒
          if (exp - now < refreshThreshold) {
            localStorage.removeItem("auth_token");
            localStorage.removeItem("auth_token_expiry");
            // console.log("Auth Token is about to expire. Refreshing...");
            await initializeAuth();
          }
        }

        const sasExpiry = sessionStorage.getItem("mindmap_sas_expiry");

        if (sasExpiry) {
          const sasExpiryMs = Date.parse(sasExpiry); // 将 ISO 格式时间解析为时间戳（毫秒）
          // console.log("Current Time:", now, "SAS Expiry Time:", sasExpiryMs);

          if (sasExpiryMs - now < refreshThreshold) {
            console.log("SAS Token is about to expire. Refreshing...");
            await getMindMapSas();
          }
        }
      }, 60 * 1000); // 每分检查一次
    }


    const getMindMapSas = async () => {
      try {
        const res = await api.mindmapAPI.getMindMapSas();
        // 提取 token 并存储到 mindMapStore
        const { token, expiresOn } = res;
        mindMapStore.setMindMapBlobSas(token); // 存储 token

        sessionStorage.setItem("mindmap_sas_expiry", expiresOn.toString());

        initMindMapBlob();
      } catch (error) {
        console.error("Error fetching MindMap SAS:", error);
        // 可以根据需要添加更多错误处理逻辑
      }
    }


    const initMindMapBlob = () => {
      if (mindMapStore.mindMapBlobsasurl) {
        const serviceClient = new BlobServiceClient(
          mindMapStore.mindMapBlobsasurl + "?" + mindMapStore.mindMapBlobSas
        );
        const containerClient = serviceClient.getContainerClient("");
        mindMapStore.setMindMapBlobContainerClient(containerClient);
      }
    }

    const mindMapUploadFile = (currentFile, noTimeTitle = false) => {
      //跟konvaCanvasUploadFile 相同，之後要再細分資料夾
      let times = new Date().getTime();
      return new Promise((r, j) => {
        let promises = [];
        let targetfilename = noTimeTitle ? currentMindMap.value.id + "/" + currentFile.name : currentMindMap.value.id + "/" + times + currentFile.name;
        let blockBlobClient = mindMapStore.mindMapBlobContainerClient.getBlockBlobClient(targetfilename);
        promises.push(blockBlobClient.uploadBrowserData(currentFile));

        Promise.all(promises).then(
          () => {
            let finallink = mindMapStore.mindMapBlobsasurl + targetfilename;
            r({
              url: finallink,
              name: targetfilename,
            });
          },
          (err) => {
            j(err);
          }
        );
      });
    }
    const dataURLtoFile = (dataurl, filename) => {
      const arr = dataurl.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    };

    const replaceSingleImageSrc = async (topic) => {
      let container = document.createElement("div");
      container.innerHTML = topic; // 解析 HTML 字串

      let img = container.querySelector("img");
      if (img) {
        let file = dataURLtoFile(img.src, "a.png");
        let uploadedFile = await mindMapUploadFile(file);
        img.src = uploadedFile.url + "?" + mindMapStore.mindMapBlobSas; // 替換 src
      }

      return container.innerHTML; // 返回更新後的 HTML 字串
    }
    //上傳到Sharing 預處理使用
    const uploadNodeImages = async (data) => {
      let uploadPromises = data.map(async (item) => {
        if (item.nodeImg) {
          let file = dataURLtoFile(item.nodeImg, "a.png"); // 轉 File
          let uploadedFile = await mindMapUploadFile(file); // 上傳 Azure Blob
          item.nodeImg = uploadedFile.url + "?" + mindMapStore.mindMapBlobSas; // 替換成 Azure Blob URL
          // 替換 <img> src
          if (item.topic && typeof item.topic === "string") {
            item.topic = await replaceSingleImageSrc(item.topic);
          }
        }
        return item;
      });

      return await Promise.all(uploadPromises);
    }


    onMounted(async () => {
      await initializeAuth();
      await getMindMapSas();
      startTokenRefreshInterval(); // 啟用檢查機制
      
      // 檢查是否有 blob URL 參數需要載入
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has('loadBlob') && urlParams.get('loadBlob') === 'true') {
        if (urlParams.has('blobUrl')) {
          try {
            // 解密 blob URL
            const encryptedBlobUrl = urlParams.get('blobUrl');
            const decryptedBlobUrl = CryptoJS.AES.decrypt(encryptedBlobUrl, "mindmapBlob").toString(CryptoJS.enc.Utf8);
            
            console.log('解密的 Blob URL:', decryptedBlobUrl);
            
            // 使用當前的SAS token構建完整URL
            const fullBlobUrl = decryptedBlobUrl + "?" + mindMapStore.mindMapBlobSas + "&t=" + new Date().getTime();
            console.log('完整 Blob URL:', fullBlobUrl);
            
            // 從 blob 讀取 JSON 數據
            const response = await fetch(fullBlobUrl);
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            const nodeTreeData = await response.json();

            console.log('從 Blob 載入的心智圖數據:', nodeTreeData);

            // 更新所有節點的圖片 SAS Token
            if (nodeTreeData.data) {
              that.replaceNodeImgUrl(nodeTreeData.data, mindMapStore.mindMapBlobSas);
              console.log('已更新圖片 SAS Token');
            }

            // 設置為唯讀模式
            that.readOnlyMode = true;


            that.mind = nodeTreeData;

            // 延遲顯示心智圖
            setTimeout(() => {
              that.jm.show(that.mind);
              that.jm.view.relayout();
            }, 200);
            
          } catch (error) {
            console.error('載入靜態心智圖失敗:', error);
            alert(this.$t('mindmap.staticMindmap.loadFailed') + '：' + error.message);
          }
        }
      }
    });


    return {
      iviewMessage,
      containerSchema,
      fluidIsDeleting,
      fluidCoworkMode,
      fluidContainer,
      fluidMindData,
      uploadNodeImages,
      currentMindMap,
      router,
    }
  },

  data() {
    return {
      isPhonetic: false,
      isZHTW: false,
      fontLoaded: false,
      fontLoading: false,
      verticalLines: [],
      horizontalLines: [],
      jmNodeAttechIcon: jmNodeIconStr.attachment,
      jm: null,
      ctrlNodeMode: "add",
      currentNode: null,
      showAddNoteTool: false,
      nodeText: '',
      direction: 'left',
      nodeTextNote: '', //更詳細的說明文字
      nodeTextURL: '',
      isCurrentSelectRoot: false,
      isCurrentNodeCanBeDelete: false,
      isCurrentNodeCanMoveUp: false,
      isCurrentNodeCanMoveDown: false,
      isCurrentNodeHasChildren: false,
      showNodeMenu: false,
      currentNodeHasImg: false,
      posX: 0,
      posY: 0,
      //協作畫板blob相關，HT初始化提供
      blobServiceClient: "",
      containerClient: "",
      activityRecordNumber: '',
      blobUrl: '',
      blobSasRead: '',
      blobSasWrite: '',
      currentTitle: '',
      currentCoworkType: '',
      showAllTool: true,
      fromInfo: {
        seat: "wb",
        name: this.$t("webirs.konvaCanvas.教師")
      },
      initMind: "",

      mind: "",
      options: {
        log_level: "error",
        container: "jsmind_container",
        editable: false,
        theme: "webirs",
        support_html: true,
        view: {
          engine: "svg",
          line_width: 4, // 線條粗細
          line_color: "#84c9c2", // 線條顏色
        },
      },
      maxImageSize: 3,
      isOverMaxImageSize: false,
      currentImgUrl: '',
      isUploadImg: false,
      showSelectedNote: false,
      showImgViewer: false,
      currentImgViewerSrc: "",
      nodeEditBy: { seat: '', name: '' },
      showMoreSetting: false,
      currentLineColor: 'red',
      currentNodeColor: 'rgb(255, 238, 139)',
      lineColorArr: ['red', 'orange', 'yellow', 'cyan', '#e0e0e0', 'brown', 'purple', 'green', '#0000ff', 'black'],
      nodeColorArr: ['rgb(255, 238, 139)', 'rgb(211, 255, 139)', 'rgb(139, 243, 255)', 'rgb(255, 191, 215)'],
      //重播用變數
      isCoworkReplay: false,
      isPauseReplay: false,
      replayFastMode: false,
      replayTimeoutId: null,
      currentReplayIndex: 0,
      currentReplayHistory: [],
      mindBeforeReplay: '', //重播前先存完整的mind，停止重播用，與konva用session備份不同
      currentHistoryForMenu: [], //給節點用的，基本上跟Replay 一樣 會在stop提供
      showViewNodeHistoryMenuItem: false, //判斷有給歷史才能秀在menu
      showNodeHistory: false, //實際秀出節點歷史
      currentNodeHistory: [], //選中的節點史
      showImgEditor: false,
      inputImgFileBeforeOpenCanvas: '',
      htexPushFilePath: '',
      htexPushSasRead: '',
      readOnlyMode: false, //給物件化推送僅允許選單讀取，不可提供編輯
      isCurrentNodeLock: false,
      isCurrentNodePreEditByMe: false,
      showMoveTool: false,
      treeMenuData: "",
      currentMoveTargetNode: "",
      nameLabelX: 0,
      nameLabelY: 0,
      currentNameLabel: '',
      showNameLabel: false,
      drawLineTimeoutId: null,
      drawLineAreaH: 0,
      isAskJumpSharing: false, // 提供跳轉到sharing網站
      isUploadSharing: false,
      sharingURL: '',
      userInfoFromHTInit: "",
      isCurrentNodeCanMoveLeft: false,
      isCurrentNodeCanMoveRight: false,
      hostSoftwareVersion: '',
      isFinishUploadToSharing: false,
      showShareLinkBox: false,
      currentMindMapURL: "",
      coworkModeCate: ["edit", "view"],
      shortURLHost: "https://hiteach.cc/"
    }
  },
  watch: {
    async isPhonetic(newValue) {
      // console.log('isPhonetic watch 觸發, 新值:', newValue);

      // 如果開啟注音且字體尚未載入，則載入字體
      if (newValue && !this.fontLoaded) {
        // console.log('需要載入字體, fontLoaded:', this.fontLoaded);
        const success = await this.loadPhoneticFont();
        if (!success) {
          // 字體載入失敗，關閉注音模式
          this.isPhonetic = false;
          this.$message.error(this.$t('mindmap.phoneticFont.loadFailed'));
          return;
        }
      }

      this.relayout();
    },
    showNameLabel(value) {
      if (value == false) {
        this.currentNameLabel = '';  // 清空當前標籤內容
        // 獲取所有 .mindmap-name-label 元素並移除它們
        const nameLabels = document.querySelectorAll('.mindmap-name-label');
        nameLabels?.forEach(label => {
          label.remove();
        })
      }
    },
  },
  mounted() {
    // Vue.prototype.$mindMapInfo = this 棄用，其中一種方便接回的寫法
    this.$.appContext.provides.$mindMapInfo = this

    let serverLocation = api.main.getServerLocation();
    let dataCenter = (serverLocation.includes("cn")) ? "china" : "global";
    this.shortURLHost = confProfile.shortUrlHost[dataCenter];


    //測試markdown使用
    // this.mind=md.mdToJsMind(md.testMDFormat(this),this)
    this.init_data();
    setTimeout(() => {
      this.jm.show(this.jm.get_data("node_tree"))
      this.jm.view.relayout()
    }, 200)

    let that = this;
    let jmDom = document.getElementById("jsmind_container");

    this.isZHTW = this.$i18n.locale.toLowerCase() == 'zh-tw'
    console.log('語言設定:', this.$i18n.locale, 'isZHTW:', this.isZHTW)

    jmDom.addEventListener("contextmenu", function (e) {
      e.preventDefault();
    });
    jmDom.addEventListener("click", function (e) {
      that.handleNodeMenu(e)
      if (e.target.className == 'mindmap-img') {
        if (e.target?.src) {
          that.currentImgUrl = e.target.src
          that.viewBigImg()
        }
      }
    });

    jmDom.addEventListener("dblclick", function (e) {
      that.handleEdit(e);
    });

    document.addEventListener("keyup", function (e) {
      if (that.showAddNoteTool) {
        if (e.key == 'Enter') {
          that.confirm()
        }
      }
    })

    // Variables to store mouse position
    let startX, startY;
    // Mouse down event listener
    // 滑鼠按下事件監聽器
    jmDom.addEventListener('mousedown', function (event) {
      event.preventDefault();
      startX = event.clientX;
      startY = event.clientY;
      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    });

    const scrollFactor = 1;

    // 滑鼠移動事件監聽器
    function onMouseMove(event) {
      // 計算滑鼠移動的偏移量
      const deltaX = event.clientX - startX;
      const deltaY = event.clientY - startY;

      // 更新捲動位置
      let jmInner = jmDom.querySelector(".jsmind-inner");
      jmInner.scrollLeft -= deltaX * scrollFactor;
      jmInner.scrollTop -= deltaY * scrollFactor;

      // 更新滑鼠位置
      startX = event.clientX;
      startY = event.clientY;
    }

    // 滑鼠釋放事件監聽器
    function onMouseUp() {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    }


    this.$nextTick(() => {
      if (window?.chrome?.webview) {
        window?.chrome?.webview.addEventListener(
          "message",
          async function (e) {
            console.log(e)
            let msg = JSON.parse(e.data)

            if (msg.action == 'initialMindMap') {
              console.log(msg.parameters, "initialMindMap")

              that.showViewNodeHistoryMenuItem = false
              that.currentHistoryForMenu = []
              that.activityRecordNumber = msg.parameters.activityRecordNumber
              that.blobUrl = that.isTool ? "" : msg.parameters?.blobUrl
              that.blobSasRead = that.isTool ? "" : msg.parameters?.blobSasRead
              that.blobSasWrite = that.isTool ? "" : msg.parameters?.blobSasWrite
              that.currentTitle = that.isTool ? "" : msg.parameters?.title
              that.currentCoworkType = that.isTool ? "" : msg.parameters?.coworkType
              that.hostSoftwareVersion = msg.parameters?.hostSoftwareVersion;

              //先判斷是工具版本號是否詢問要跳轉到新版本，不可動到舊版邏輯!!!
              // 處理教具模式的登入狀態與Blob設定
              if (that.isTool) {
                that.handleToolModeAuth(msg.parameters);
              }

              // 統一處理心智圖初始化
              that.initializeMindMap(msg.parameters)

            }
            if (msg.action == 'initialMindMapByMD') {
              that.showViewNodeHistoryMenuItem = false
              that.currentHistoryForMenu = []
              that.activityRecordNumber = msg.parameters.activityRecordNumber
              that.blobUrl = that.isTool ? "" : msg.parameters?.blobUrl
              that.blobSasRead = that.isTool ? "" : msg.parameters?.blobSasRead
              that.blobSasWrite = that.isTool ? "" : msg.parameters?.blobSasWrite
              that.currentTitle = that.isTool ? "" : msg.parameters?.title
              that.currentCoworkType = that.isTool ? "" : msg.parameters?.coworkType
              that.hostSoftwareVersion = msg.parameters?.hostSoftwareVersion;

              // 處理教具模式的登入狀態與Blob設定
              if (that.isTool) {
                that.handleToolModeAuthForMD(msg.parameters);
              }

              // 統一處理 MD 格式心智圖初始化
              that.initializeMindMapFromMD(msg.parameters)
            }
            else if (msg.action == "ScreenLarge") {
              if (that.currentCoworkType != 'All') {
                that.showAllTool = true
              }
              that.$q.loading.show()
              setTimeout(() => {
                that.jm.resize();
                that.$q.loading.hide()
              }, 100)
            }
            else if (msg.action == "ScreenNormal") {
              if (that.currentCoworkType != 'All') {
                that.showAllTool = false
              }
              that.$q.loading.show()
              setTimeout(() => {
                that.jm.resize();
                that.$q.loading.hide()
              }, 100)
            }
            else if (msg.action == 'Snapshot.Get') {
              that.sendBase64toHTWb()
            }
            else if (msg.action == 'MD.Get') {
              that.sendMDtoHTWb()
            }
            else if (msg.action == 'GetAllBackup') {
              let isForLocalSave = msg.hasOwnProperty("isForLocalSave") ? msg.isForLocalSave : false
              that.sendBackToHTWb("LayerBackup", isForLocalSave)
            }
            else if (msg.action == 'GetAll') { //HT 向 ＷebIRS 傳 Cowork.Doc.Push
              that.sendBackToHTWb("layerAllWb")
            }
            else if (msg.action == 'Relayout') {
              that.relayout()
            }
            else if (msg.action == 'RefreshSelf') {
              that.closeAllToolBox()
              that.showViewNodeHistoryMenuItem = false
              that.currentHistoryForMenu = []
              that.$q.loading.show()
              setTimeout(() => {
                that.jm.show(that.jm.get_data("node_tree"))
              }, 50)
              that.jm.resize();
              setTimeout(() => {
                that.sendBackToHTWb("RefreshClients")
                that.$q.loading.hide()
              }, 50)
            }
            else if (msg.action == 'Replay') {
              that.mindBeforeReplay = that.jm.get_data("node_tree")
              that.replayFastMode = false
              that.isPauseReplay = false
              if (that.replayTimeoutId !== null) {
                clearTimeout(that.replayTimeoutId);
                that.replayTimeoutId = null;
              }
              that.isCoworkReplay = true
              that.currentReplayHistory = msg.actionHistory
              //先清空到原始
              that.jm.show(that.initMind);
              setTimeout(() => {
                that.replayAction(0);
              }, 100)

            }
            else if (msg.action == 'StopReplay') {
              that.isCoworkReplay = false
              that.currentReplayIndex = 0
              that.isWaitingStopReplayRefresh = true
              if (that.replayTimeoutId !== null) {
                clearTimeout(that.replayTimeoutId);
                that.replayTimeoutId = null;
              }
              that.jm.show(that.mindBeforeReplay); //回到重播前的mind
            }
            else if (msg.action == 'RefreshAll') {
              that.closeAllToolBox()
              that.showViewNodeHistoryMenuItem = false
              that.currentHistoryForMenu = []
              if (msg.lastedAll == "") {
                that.$q.loading.show()
                that.jm.show(that.initMind);
                setTimeout(() => {
                  that.sendBackToHTWb("RefreshClients")
                  that.$q.loading.hide()
                }, 50)
              }
              else {
                that.$q.loading.show()
                that.mind = JSON.parse(JSON.parse(msg.lastedAll).item)
                that.jm.show(that.mind)
                setTimeout(() => {
                  that.sendBackToHTWb("RefreshClients")
                  that.$q.loading.hide()
                }, 50)
              }
            }
            else if (msg.action == 'MindMapHistory') {
              that.showViewNodeHistoryMenuItem = true
              that.currentHistoryForMenu = msg.actionHistory
            }
            else { //各種動作的更新
              that.updateStageNode(JSON.parse(e.data));
            }
          })
      }
    })

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('webmind') && urlParams.get('webmind') === 'true') {
      if (urlParams.has('webapp_obj')) {

        const rawEncrypted = decodeURIComponent(urlParams.get('webapp_obj'));
        const decryptedUrl = enc.decrypt(rawEncrypted, "fromWebIRS");

        fetch(decryptedUrl)
          .then((res) => {
            return res.text();
          })
          .then((data) => {
            // console.log(data)
            let Jdata = JSON.parse(data)
            that.readOnlyMode = true
            that.initMind = JSON.parse(Jdata.webmind_data)
            that.mind = JSON.parse(Jdata.webmind_data)
            setTimeout(() => {
              that.jm.show(that.mind)
              that.jm.view.relayout()
            }, 200)
          })
          .catch((error) => {
            console.error('Error fetching the text file:', error); // 處理可能的錯誤
          });

      }
    }

  },
  computed: {
    showSaveCoworkBtn() {
      return this.currentMindMap.coworkMode && this.$refs.coworkModeSelect.currentSelect != this.currentMindMap.coworkMode;
    },
    nodeTextLength() {
      return this.nodeText.length
    },
    nodeTextNoteLength() {
      return this.nodeTextNote.length
    },

  },
  methods: {
    // 檢查版本是否支援分享功能
    isVersionSupportsSharing() {
      if (!this.hostSoftwareVersion) return false;
      
      const versionParts = this.hostSoftwareVersion.split('.');
      const majorMinor = parseFloat(`${versionParts[0]}.${versionParts[1]}`);
      
      return majorMinor >= 5.5 || parseFloat(versionParts[0]) >= 6;
    },

    // 檢查登入狀態參數是否完整
    hasCompleteAuthParams(parameters) {
      const requiredParams = ['login_Id', 'blobUrl', 'blobSasRead', 'blobSasWrite', 'id_Token', 'access_Token'];
      return requiredParams.every(param => parameters[param] && parameters[param] !== '');
    },

    mindMapUploadFileForHTBlob(currentFile) { //跟konvaCanvasUploadFile 相同
      let times = new Date().getTime();
      return new Promise((r, j) => {
        let promises = [];
        let targetfilename = "records/" + this.activityRecordNumber + '/Clients/' + currentFile.name;
        let blockBlobClient = this.containerClient.getBlockBlobClient(targetfilename);
        promises.push(blockBlobClient.uploadBrowserData(currentFile));

        Promise.all(promises).then(
          (res) => {
            let finallink = this.blobUrl + "/" + targetfilename;
            r({
              url: finallink,
              name: times + currentFile.name,
            });
          },
          (err) => {
            j(err);
          }
        );
      });
    },

    // 設定使用者認證資訊
    setupUserAuth(parameters) {
      const name = jwt_decode(parameters.id_Token).name;
      const decoded = jwt_decode(parameters.id_Token);

      const userInfo = {
        login_Id: parameters.login_Id,
        id_Token: parameters.id_Token,
        access_Token: parameters.access_Token,
        expires_in: parameters.expires_in,
        from: 'HT',
        name: name
      };

      const profile = {
        name: decoded.name,
        teammodelId: decoded.sub,
        picture: decoded.picture,
      };

      localStorage.setItem("access_token", parameters.access_Token);
      localStorage.setItem("id_token", parameters.id_Token);
      localStorage.setItem("expires_in", parameters.expires_in);
      localStorage.setItem("profile", JSON.stringify(profile));
      sessionStorage.setItem("jumpFrom", "HT");

      this.userInfoFromHTInit = userInfo;
    },

    // 處理分享跳轉
    handleSharingRedirect(parameters) {
      if (parameters.sharingID && parameters.sharingID !== "") {
        const mindMapID = parameters.sharingID;
        this.sharingURL = window.location.origin + `/MindMapClone?id=${mindMapID}`;
        window.location.href = this.sharingURL;
      }
    },

    // 處理教具模式的認證設定
    handleToolModeAuth(parameters) {
      if (!this.isVersionSupportsSharing()) return;

      // 檢查是否為未登入狀態
      if (!this.hasCompleteAuthParams(parameters)) {
        this.iviewMessage.warning({
          content: this.$t('mindmap.auth.notLoggedInShareWarning'),
          duration: 10,
          closable: true
        });
        this.initializeMindMap(parameters);
        return;
      }

      // 設定 Blob 相關參數
      this.blobUrl = parameters.blobUrl;
      this.blobSasRead = parameters.blobSasRead;
      this.blobSasWrite = parameters.blobSasWrite;
      this.initblob();

      console.log(this.hostSoftwareVersion, ":可提供跳轉到Sharing的教具版本");

      // 設定使用者認證
      this.setupUserAuth(parameters);

      // 處理分享跳轉
      this.handleSharingRedirect(parameters);

      // 設定分享相關狀態
      this.isAskJumpSharing = parameters.isFirstShow ?? true;
      this.isUploadSharing = true;
    },

    // 建立預設心智圖資料
    createDefaultMindMap() {
      return {
        meta: {
          name: "jsMind-demo-tree",
          author: "",
          version: "",
        },
        format: "node_tree",
        data: {
          id: "root",
          topic: "<p>" + this.$t("mindmap.defaultMind.root") + "</p>",
          expanded: true,
          lock: false,
          children: [
            {
              id: "uuid1",
              topic: "<p>" + this.$t("mindmap.defaultMind.node1") + "</p>",
              expanded: true,
              direction: "left",
              nodeText: this.$t("mindmap.defaultMind.node1"),
              nodeImg: "",
              nodeLink: "",
              lineColor: "red",
              "background-color": "rgb(255, 191, 215)",
              lock: false
            },
            {
              id: "uuid2",
              topic: "<p>" + this.$t("mindmap.defaultMind.node2") + "</p>",
              expanded: true,
              direction: "left",
              nodeText: this.$t("mindmap.defaultMind.node2"),
              nodeImg: "",
              nodeLink: "",
              lineColor: "#0000ff",
              "background-color": "rgb(139, 243, 255)",
              lock: false
            },
            {
              id: "uuid3",
              topic: "<p>" + this.$t("mindmap.defaultMind.node3") + "</p>",
              expanded: true,
              direction: "right",
              nodeText: this.$t("mindmap.defaultMind.node3"),
              nodeImg: "",
              nodeLink: "",
              lineColor: "orange",
              "background-color": "rgb(255, 238, 139)",
              lock: false
            },
            {
              id: "uuid4",
              topic: "<p>" + this.$t("mindmap.defaultMind.node4") + "</p>",
              expanded: true,
              direction: "right",
              nodeText: this.$t("mindmap.defaultMind.node4"),
              nodeImg: "",
              nodeLink: "",
              lineColor: "green",
              "background-color": "rgb(211, 255, 139)",
              lock: false
            }
          ]
        },
      };
    },

    // 統一處理心智圖初始化
    initializeMindMap(parameters) {
      // 設定心智圖資料
      if (!parameters.mind || parameters.mind === '') {
        this.mind = this.createDefaultMindMap();
      } else {
        const parsedMind = JSON.parse(parameters.mind);
        // 檢查是否只有根節點沒有子節點
        if (!parsedMind.data || (!parsedMind.data.children || parsedMind.data.children.length === 0)) {
          console.log("沒有子節點,使用預設心智圖");
          this.mind = this.createDefaultMindMap();
        } else {
          this.mind = parsedMind;
        }
      }

      this.initMind = JSON.parse(JSON.stringify(this.mind));

      // 設定協作模式
      if (this.currentCoworkType != 'All') {
        this.showAllTool = false;
      }

      // 初始化 blob (非教具模式才需要)
      if (!this.isTool) {
        this.initblob();
      }

      // 顯示心智圖
      this.showMindMapWithLoading();
    },

    // 處理 MD 格式的心智圖初始化
    initializeMindMapFromMD(parameters) {
      // 設定心智圖資料 (使用 MD 格式轉換)
      if (!parameters.mind || parameters.mind === '') {
        this.mind = this.createDefaultMindMap();
      } else {
        let mdData = parameters.mind;
        // 建立包含必要方法的 VM 物件給 mdToJsMind 使用
        this.mind = md.mdToJsMind(mdData, this);
      }

      this.initMind = JSON.parse(JSON.stringify(this.mind));

      // 設定協作模式
      if (this.currentCoworkType != 'All') {
        this.showAllTool = false;
      }

      // 初始化 blob (非教具模式才需要)
      if (!this.isTool) {
        this.initblob();
      }

      // 顯示心智圖
      this.showMindMapWithLoading();
    },

    // 處理教具模式認證 (簡化版，用於 MD 初始化)
    handleToolModeAuthForMD(parameters) {
      if (!this.isVersionSupportsSharing()) return;

      // 檢查是否為未登入狀態
      if (!this.hasCompleteAuthParams(parameters)) {
        this.iviewMessage.warning({
          content: this.$t('mindmap.auth.notLoggedInShareWarning'),
          duration: 10,
          closable: true
        });
        this.initializeMindMapFromMD(parameters);
        return;
      }

      // 設定 Blob 相關參數
      this.blobUrl = parameters.blobUrl;
      this.blobSasRead = parameters.blobSasRead;
      this.blobSasWrite = parameters.blobSasWrite;
      this.initblob();

      console.log(this.hostSoftwareVersion, ":可提供跳轉到Sharing的教具版本");

      // 設定使用者認證
      this.setupUserAuth(parameters);

      // 處理分享跳轉
      this.handleSharingRedirect(parameters);

      // 設定分享相關狀態
      this.isAskJumpSharing = parameters.isFirstShow ?? true;
      this.isUploadSharing = true;
    },

    // 顯示心智圖並處理載入狀態
    showMindMapWithLoading() {
      this.$q.loading.show();
      setTimeout(() => {
        this.jm.show(this.mind);
        this.jm.view.relayout();
        this.$q.loading.hide();
        this.sendSizeToHTWb();
      }, 1000);
    },

    async initializeAzureClient() {
      try {
        localStorage.removeItem("cachedFluidRelayToken"); // 初始化先移除 localStorage
        const fluidConfig = await api.mindmapAPI.getFluidRelayConfig();
        let serverLocation = api.main.getServerLocation();
        let dataCenter = (serverLocation.includes("cn")) ? "china" : "global";

        console.log(this.userInfoFromHTInit)

        const serviceConfig = {
          connection: {
            type: "remote",
            tenantId: fluidConfig[dataCenter]?.fluidRelayTenantId,
            tokenProvider: new api.MyAzTokenProvider(api.mindmapAPI.fluidTokenUrl, {
              "idToken": "",
              "id": this.userInfoFromHTInit?.login_Id,
              "name": this.userInfoFromHTInit.name,
            }),
            endpoint: fluidConfig[dataCenter]?.fluidRelayEndpoint,
          },
        };
        return new AzureClient(serviceConfig);
      } catch (error) {
        console.error("初始化 AzureClient 失敗:", error);
        this.$q.loading.hide();
        throw error;
      }
    },
    async saveCoworkMode() {
      try {
        // 將設定寫回 API
        await api.mindmapAPI.updateMindMap({
          id: this.currentMindMap.id,
          mindmapEditor: {
            id: this.currentMindMap.mindmapEditor.id,
            name: this.currentMindMap.mindmapEditor.name,
          },
          coworkMode: this.$refs.coworkModeSelect.currentSelect,
        });
        this.currentMindMap.coworkMode = this.$refs.coworkModeSelect.currentSelect;

        this.fluidCoworkMode.set('data', JSON.stringify({
          "coworkMode": this.$refs.coworkModeSelect.currentSelect,
          "openCowork": true,
        }));
        this.closeShareLinkBox();
        this.iviewMessage.info(this.$t("mindmap.mindmapHome.saveOk"));
      } catch (error) {
        console.error("儲存失敗：", error);
      }
    },
    closeShareLinkBox() {
      this.showShareLinkBox = false;
    },

    async createInSharing() {
      //需將目前本地的資料傳到sharing
      // console.log(toRaw(this.jm?.get_root())?.data?.nodeText)
      this.$q.loading.show()
      this.handleTokenExpiry()

      try {
        const data = {
          "mindmapName": toRaw(this.jm?.get_root())?.data?.nodeText || this.$t("mindmap.defaultMind.root"),
          "mindmapCreator": {
            "id": this.userInfoFromHTInit.login_Id,
            "name": this.userInfoFromHTInit.name
          },
          "mindmapData": "",
          "fluidContainerId": "",
          "openCowork": true,
          "coworkMode": "edit",
        }

        // Step 1: Initialize Azure Client
        let client;
        try {
          client = await this.initializeAzureClient();
        } catch (error) {
          console.error("Azure Client 初始化失敗:", error);
          this.iviewMessage.error(this.$t("webirs.mindmap.initSharingFailed"));
          return;
        }

        // Step 2: Create Fluid Container
        let container;
        try {
          const containerResult = await client.createContainer(this.containerSchema, "2;");
          container = containerResult.container;
          data.fluidContainerId = await container.attach();
        } catch (error) {
          console.error("Fluid Container 建立失敗:", error);
          this.iviewMessage.error(this.$t("webirs.mindmap.initSharingFailed"));
          return;
        }

        // Step 3: Initialize Fluid Objects
        try {
          this.fluidIsDeleting = container.initialObjects.isDeleting;
          this.fluidCoworkMode = container.initialObjects.coworkMode;
          this.fluidMindData = container.initialObjects.mindData;

          this.fluidIsDeleting.set('data', false);
          this.fluidCoworkMode.set('data', JSON.stringify({
            "coworkMode": "edit",
            "openCowork": true,
          }));
        } catch (error) {
          console.error("Fluid 物件初始化失敗:", error);
          this.iviewMessage.error(this.$t("webirs.mindmap.initSharingFailed"));
          return;
        }

        // Step 4: Upload Node Images
        let initMindData;
        try {
          const jsmindArrData = this.jm.get_data("node_array")
          initMindData = await this.uploadNodeImages(jsmindArrData.data);
          console.log(initMindData, "上傳圖片後的資料")
        } catch (error) {
          console.error("圖片上傳失敗:", error);
          this.iviewMessage.error(this.$t("webirs.mindmap.initSharingFailed"));
          return;
        }

        // Step 5: Save Data to Fluid
        try {
          const setPromises = initMindData.map(item =>
            this.fluidMindData.set(item.id, JSON.stringify(item))
          );
          await Promise.all(setPromises);
        } catch (error) {
          console.error("資料同步至 Fluid 失敗:", error);
          this.iviewMessage.error(this.$t("webirs.mindmap.initSharingFailed"));
          return;
        }

        // Step 6: Create MindMap
        let cloudMindMap;
        try {
          cloudMindMap = await api.mindmapAPI.createMindMap(data);
          this.currentMindMap = cloudMindMap;
        } catch (error) {
          console.error("心智圖建立失敗:", error);
          if (error.response?.status === 401) {
            this.handleTokenExpiry();
          } else {
            this.iviewMessage.error(this.$t("webirs.mindmap.initSharingFailed"));
          }
          return;
        }

        // Step 7: Generate Clip Code
        let clipCode;
        try {
          const origData = `${window.location.origin}/MindMapClone?id=${cloudMindMap.id}`;
          console.log(origData)

          const clipData = {
            "origDataList": [{ "origData": origData }],
            "type": "mindmap",
            "useShortDigits": false,
            "isPermanent": false,
            "lang": this.$i18n.locale.toLowerCase(),
            "note": JSON.stringify({mindmapName:data.mindmapName})
          };
          const clipCodeRes = await api.mindmapAPI.getClipCode(clipData);
          clipCode = clipCodeRes.clipCodePairs[0].clipCode;
        } catch (error) {
          console.error("簡碼生成失敗:", error);
          if (error.response?.status === 401) {
            this.handleTokenExpiry();
          } else {
            this.iviewMessage.error(this.$t("webirs.mindmap.initSharingFailed"));
          }
          return;
        }

        // Step 8: Update MindMap with Clip Code
        try {
          await api.mindmapAPI.updateMindMap({
            id: cloudMindMap.id,
            mindmapEditor: {
              id: this.userInfoFromHTInit.login_Id,
              name: this.userInfoFromHTInit.name,
            },
            urlClipCode: clipCode
          });

          this.currentMindMapURL = clipCode;
          this.isFinishUploadToSharing = true;
        } catch (error) {
          console.error("心智圖更新失敗:", error);
          if (error.response?.status === 401) {
            this.handleTokenExpiry();
          } else {
            this.iviewMessage.error(this.$t("webirs.mindmap.initSharingFailed"));
          }
          return;
        }

        // Success
        this.iviewMessage.info(this.$t("webirs.mindmap.createSuccess"));
        this.router.push({
          path: '/MindMapClone',
          query: {
            id: cloudMindMap.id,
            showShareLinkBox: true
          }
        });

      } catch (error) {
        // Catch any unexpected errors
        console.error("createInSharing 發生未預期的錯誤:", error);
        this.iviewMessage.error(this.$t("webirs.mindmap.unexpectedError"));
      } finally {
        // Always hide loading
        this.$q.loading.hide();
      }
    },

    // 處理 Token 過期
    handleTokenExpiry() {
      // 檢查 access_token 是否過期
      const isExpired = this.checkAccessTokenExpired();

      if (isExpired) {
        this.iviewMessage.error(this.$t("webirs.mindmap.authError"));
      }
    },

    // 檢查 access_token 是否過期
    checkAccessTokenExpired() {
      const expiresIn = localStorage.getItem("expires_in");
      if (!expiresIn) return true; // 沒有過期時間，視為過期

      try {
        const now = new Date();
        const currentTime = Date.parse(now);

        let formattedExpiresIn = expiresIn;
        if (!formattedExpiresIn.includes("T")) {
          formattedExpiresIn = formattedExpiresIn.replace(" ", "T");
          formattedExpiresIn = formattedExpiresIn + "+00:00";
        }

        const expiryTime = Date.parse(formattedExpiresIn);
        const timeDiff = expiryTime - currentTime;

        // 如果已過期或即將在 30 秒內過期
        return timeDiff <= 30 * 1000;
      } catch (error) {
        console.error("檢查 token 過期時發生錯誤:", error);
        return true; // 檢查失敗，視為過期
      }
    },

    copyShortUrl() {
      const url = this.shortURLHost + this.currentMindMapURL;
      const input = document.createElement('input');
      input.value = url;
      document.body.appendChild(input);
      input.select();
      document.execCommand('Copy');
      document.body.removeChild(input);
      this.iviewMessage.info(this.$t("mindmap.mainMenu.alreadyCopied"));
    },
    uploadMindMapToBlobTemp(data, JsonName) {
      let times = new Date().getTime()
      let finalName = JsonName + times
      return new Promise((r, j) => {
        let promises = []
        let targetfilename = 'temp/' + finalName
        let blockBlobClient = this.containerClient.getBlockBlobClient(targetfilename);
        promises.push(blockBlobClient.uploadBrowserData(JSON.stringify(data)))

        Promise.all(promises).then(
          res => {
            console.log("上傳mindmap到blob", this.blobUrl + "/" + targetfilename + '?' + this.blobSasRead);
            r({
              url: this.blobUrl + "/" + targetfilename + '?' + this.blobSasRead
            })
          },
          err => {
            j(err)
          }
        )
      })
    },
    confirmJumpSharing() {
      this.sharingURL = window.location.origin + `/MindMapHome`;
      window.location.href = this.sharingURL;
    },
    selectLocalMindMap() {
      this.isAskJumpSharing = false
    },
    //加密函數
    encryptData(data, key) {
      const jsonData = JSON.stringify(data); // 转为字符串
      const encrypted = CryptoJS.AES.encrypt(jsonData, key).toString(); // AES 加密
      return encodeURIComponent(encrypted); // URL 安全编码
    },
    relayout() {
      //測試markdown使用
      // this.sendMDtoHTWb()
      setTimeout(() => {
        this.jm.show(this.jm.get_data("node_tree"))
        this.jm.view.relayout()
      }, 200)
    },
    openEditor() {
      this.inputImgFileBeforeOpenCanvas = this.currentImgUrl
      this.showImgEditor = true
    },
    toggleNodeLock() {
      this.currentNode = this.jm.get_selected_node()


      this.isCurrentNodeLock = !this.currentNode.data?.lock


      this.currentLineColor = this.currentNode.data?.lineColor
      this.currentNodeColor = this.currentNode.data?.['background-color']

      let tempDiv = document.createElement("div");
      tempDiv.innerHTML = this.currentNode.topic;
      let filteredString = tempDiv.querySelector('p').textContent;
      this.nodeText = filteredString;
      let imgElement = tempDiv.querySelector('img');
      // 獲取圖片的 src 屬性值
      this.currentImgUrl = imgElement ? imgElement.src : "";

      let urlElement = tempDiv.querySelector('a');
      this.nodeTextURL = urlElement ? urlElement.href : "";
      this.nodeTextURLName = urlElement ? urlElement.textContent : "";
      this.isCurrentSelectRoot = false
      this.nodeTextNote = this.currentNode?.data?.note || ''

      let itemInfo = {
        fromInfo: this.fromInfo,
        note: this.nodeTextNote,
        lineColor: this.currentLineColor,
        'background-color': this.currentNodeColor, //按照jsMind套件中的命名
        nodeText: this.nodeText,
        nodeImg: "",
        nodeLink: "",
        lock: this.isCurrentNodeLock
      }


      let itemContent = `<p>${this.nodeText}</p>`
      if (this.currentImgUrl != '') {
        itemContent += `<img class='mindmap-img' src="${this.currentImgUrl}"/><br>`
        itemInfo.nodeImg = this.currentImgUrl
      }

      if (this.nodeTextURL.trim() != '') {
        let url = this.fixURL(this.nodeTextURL)
        itemContent += `<a class="node-url" target="_blank" href="${url}">${this.jmNodeAttechIcon}</a>`
        itemInfo.nodeLink = url
      }


      this.jm.enable_edit() //啟用編輯
      if (this.jm.get_node(this.currentNode.id)) {
        this.jm.update_node(this.currentNode.id, itemContent, itemInfo)
        let item = {
          nodeID: this.currentNode.id,
          nodeContent: itemContent,
          ...itemInfo
        }
        this.sendItemToHTWb('update', item)
      }
      this.jm.disable_edit() //關閉編輯
      this.showNodeMenu = false; //關閉選單

    },
    applyNodeColor() {
      // 取得選中的節點
      const selectedNode = this.jm.get_selected_node();
      if (!selectedNode) {
        return;
      }

      // 取得該節點的顏色設定
      const parentLineColor = selectedNode.data?.lineColor || this.currentLineColor;
      const parentNodeColor = selectedNode.data?.["background-color"] || this.currentNodeColor;

      // 遞迴函數：套用顏色到所有子節點
      const applyColorToChildren = (node) => {
        if (!node.children || node.children.length === 0) {
          return;
        }

        node.children.forEach((child) => {
          // 更新子節點的顏色
          const updatedData = {
            ...child.data,
            lineColor: parentLineColor,
            "background-color": parentNodeColor,
            fromInfo: this.fromInfo,
          };

          // 使用 jsMind 的 update_node 方法更新節點
          this.jm.update_node(child.id, child.topic, updatedData);

          // 同步到 HiTeach
          const item = {
            nodeID: child.id,
            nodeContent: child.topic,
            ...updatedData,
          };
          this.sendItemToHTWb('update', item);

          // 遞迴處理子節點的子節點
          applyColorToChildren(child);
        });
      };

      // 開始套用顏色
      this.jm.enable_edit(); //啟用編輯
      applyColorToChildren(selectedNode);
      this.jm.disable_edit(); //關閉編輯

      // 關閉選單
      this.showNodeMenu = false;

      // 顯示成功訊息
      this.iviewMessage.success(this.$t("mindmap.menu.applyColorSuccess"));
    },
    applyAllRightLayout() {
      // 取得根節點
      const rootNode = this.jm.get_selected_node();
      if (!rootNode || rootNode.id !== 'root') {
        this.iviewMessage.info(this.$t("webirs.mindmap.請先選取節點"));
        return;
      }

      // 檢查根節點是否有子節點
      if (!rootNode.children || rootNode.children.length === 0) {
        this.iviewMessage.info(this.$t("webirs.mindmap.menu.noChildrenToApply"));
        return;
      }

      // 啟用編輯模式
      this.jm.enable_edit();

      // 先收集所有第一層子節點的 ID（避免在迭代時修改陣列）
      const childIds = rootNode.children.map(child => child.id);

      // 將所有第一層子節點的 direction 改為 right (1)
      childIds.forEach((childId) => {
        const childNode = this.jm.get_node(childId);
        if (childNode) {
          // 設定 direction 為 1 (右邊)
          childNode.direction = 1;

          // 使用 jsMind 的 move_node 方法來更新節點位置和 direction
          this.jm.move_node(childId, "_last_", rootNode.id, 1);

          // 同步到 HiTeach (教具模式使用 sendItemToHTWb 而不是 setFluidMindNodeData)
          const item = {
            nodeID: childId,
            nodeContent: childNode.topic,
            direction: 1,
            parentid: rootNode.id,
            isexpanded: childNode.isexpanded
          };
          this.sendItemToHTWb('update', item);
        }
      });

      // 關閉編輯模式
      this.jm.disable_edit();

      // 重新佈局以確保所有節點正確顯示
      setTimeout(() => {
        this.jm.view.relayout();
      }, 100);

      // 關閉選單
      this.showNodeMenu = false;

      // 顯示成功訊息
      this.iviewMessage.success(this.$t("webirs.mindmap.menu.allRightLayoutSuccess"));
    },
    applyAllLeftLayout() {
      // 取得根節點
      const rootNode = this.jm.get_selected_node();
      if (!rootNode || rootNode.id !== 'root') {
        this.iviewMessage.info(this.$t("webirs.mindmap.請先選取節點"));
        return;
      }

      // 檢查根節點是否有子節點
      if (!rootNode.children || rootNode.children.length === 0) {
        this.iviewMessage.info(this.$t("webirs.mindmap.menu.noChildrenToApply"));
        return;
      }

      // 啟用編輯模式
      this.jm.enable_edit();

      // 先收集所有第一層子節點的 ID（避免在迭代時修改陣列）
      const childIds = rootNode.children.map(child => child.id);

      // 將所有第一層子節點的 direction 改為 left (-1)
      childIds.forEach((childId) => {
        const childNode = this.jm.get_node(childId);
        if (childNode) {
          // 設定 direction 為 -1 (左邊)
          childNode.direction = -1;

          // 使用 jsMind 的 move_node 方法來更新節點位置和 direction
          this.jm.move_node(childId, "_last_", rootNode.id, -1);

          // 同步到 HiTeach (教具模式使用 sendItemToHTWb 而不是 setFluidMindNodeData)
          const item = {
            nodeID: childId,
            nodeContent: childNode.topic,
            direction: -1,
            parentid: rootNode.id,
            isexpanded: childNode.isexpanded
          };
          this.sendItemToHTWb('update', item);
        }
      });

      // 關閉編輯模式
      this.jm.disable_edit();

      // 重新佈局以確保所有節點正確顯示
      setTimeout(() => {
        this.jm.view.relayout();
      }, 100);

      // 關閉選單
      this.showNodeMenu = false;

      // 顯示成功訊息
      this.iviewMessage.success(this.$t("webirs.mindmap.menu.allLeftLayoutSuccess"));
    },
    copyNode() {
      let copyTargetNode = this.jm.get_selected_node()
      if (copyTargetNode) {
        this.jm.enable_edit() //啟用編輯
        let itemInfo = {
          fromInfo: this.fromInfo,
          note: copyTargetNode.data?.note || '',
          lineColor: copyTargetNode.data?.lineColor,
          'background-color': copyTargetNode.data?.['background-color'],
          nodeText: copyTargetNode.data?.nodeText || '',
          nodeImg: copyTargetNode.data?.nodeImg || '',
          nodeLink: copyTargetNode.data?.nodeLink || ''
        }
        let nodeID = this.genUUID()
        this.jm.insert_node_after(copyTargetNode, nodeID, copyTargetNode.topic, itemInfo, copyTargetNode.direction)
        this.jm.disable_edit() //關閉編輯
        this.showNodeMenu = false

        let item = {
          direction: copyTargetNode.direction,
          beforeNodeID: copyTargetNode.id,
          nodeID: nodeID,
          nodeContent: copyTargetNode.topic,
          ...itemInfo
        }
        this.sendItemToHTWb('copy', item)
        this.jm.select_clear() //清除選中狀態，避免白色字體殘留

      } else {
        this.iviewMessage.info(this.$t('webirs.mindmap.請先選取節點'));
      }

    },
    reloadLayout() {
      this.$q.loading.show()
      setTimeout(() => {
        this.jm.show(this.mind)
        this.jm.view.relayout()
        this.$q.loading.hide()
      }, 1000)
    },
    setLineColor(item) {
      this.currentLineColor = item
    },
    setNodeColor(item) {
      this.currentNodeColor = item
    },

    resetImageUploader() {
      if (this.$refs.mainImageUploader) {
        this.$refs.mainImageUploader.value = ''
      }
      if (this.$refs.mainImageUploaderInit) {
        this.$refs.mainImageUploaderInit.value = ''
      }

    },
    openWhiteEditor() {
      this.isOverMaxImageSize = false
      this.inputImgFileBeforeOpenCanvas = ''
      this.showImgEditor = true
    },

    async imgfileChangeHandler(e) {
      let that = this
      this.isOverMaxImageSize = false
      //這邊圖片直接做成上傳檔案
      let files = Array.from(e.target.files)
      let fileName = e.target.files[0].name


      let fileReader = new FileReader()
      fileReader.readAsDataURL(e.target.files[0])

      fileReader.onload = e => {
        let imageObj = new Image()
        imageObj.setAttribute('crossOrigin', 'Anonymous')
        imageObj.src = e.target.result
        imageObj.onload = async function () {

          let ratio = that.calScaleRatio(imageObj.width, imageObj.height, 1024, 1024).ratio
          if (imageObj.width <= 1024 && imageObj.height <= 1024) ratio = 1
          const canvas = document.createElement('canvas')
          const context = canvas.getContext('2d')
          const originalWidth = imageObj.width
          const originalHeight = imageObj.height
          const canvasWidth = originalWidth * ratio
          const canvasHeight = originalHeight * ratio
          canvas.width = canvasWidth
          canvas.height = canvasHeight
          context.drawImage(imageObj, 0, 0, canvasWidth, canvasHeight)
          let compressFile = await that.dataURLtoFile(canvas.toDataURL('image/jpeg', 0.9), fileName)
          let size = parseFloat(compressFile.size / 1000000).toFixed(4)

          if (!size) return
          if (size > that.maxImageSize) {
            that.isOverMaxImageSize = true
          } else {

            that.isUploadImg = true
            that.$q.loading.show()
            if (!that.isTool) {
              that.mindMapUploadFileForHTBlob(compressFile).then(res => {
                console.log( res,"1924")
                that.currentImgUrl = res.url + '?' + that.blobSasRead
                that.isUploadImg = false
                that.$q.loading.hide()
              })
            }
            else {
              const file = compressFile;
              that.isUploadImg = true;
              that.$q.loading.show();

              try {
                const jpegBase64 = await that.fileToJpegBase64(file);
                that.currentImgUrl = jpegBase64;
                // console.log('轉換後的 base64：', jpegBase64);
              } catch (error) {
                console.error('轉換圖片失敗：', error);
              } finally {
                that.isUploadImg = false;
                that.$q.loading.hide();
              }
            }
          }
        }
      }
    },
    fileToJpegBase64(fileOrBlob) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;

          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);

          // 轉成 JPEG base64（設定畫質）
          const jpegBase64 = canvas.toDataURL('image/jpeg', 0.9);
          resolve(jpegBase64);
        };
        img.onerror = reject;

        // 必須先轉為 Object URL 再載入
        const objectUrl = URL.createObjectURL(fileOrBlob);
        img.src = objectUrl;
      });
    },
    getNodePos(nodeId) {

      // 精确查找目标节点
      const node = document.querySelector(`jmnode[nodeid="${nodeId}"]`);
      if (node) {
        const styles = window.getComputedStyle(node);
        return {
          left: parseFloat(styles.left) - 15,
          top: parseFloat(styles.top) - 15,
        };
      }
      return null; // 未找到返回 null


    },
    updateStageNode(actionItem) {
      if (!actionItem?.item) return
      let dont_center = true
      this.jm.enable_edit() //啟用編輯
      this.showNameLabel = false
      let item = JSON.parse(actionItem.item)
      let itemInfo = {
        fromInfo: item?.fromInfo,
        note: item?.note,
        lineColor: item?.lineColor,
        'background-color': item?.['background-color'], //按照jsMind套件中的命名
        nodeText: item?.nodeText || '',
        nodeImg: item?.nodeImg || '',
        nodeLink: item?.nodeLink || '',
        lock: item?.lock || false,
      }
      let nodeID = item?.nodeID
      let itemContent = item?.nodeContent
      let beforeNodeID = item?.beforeNodeID //先明確指示要搬到誰前面，以免協議太快先後亂掉
      let parentNodeID = item?.parentNodeID
      let direction = item?.direction

      switch (actionItem.action) {
        case "add": {
          let addTargetNode = this.jm.get_node(item.parentNodeID)
          if (addTargetNode != null && this.jm.get_node(nodeID) == null) {
            this.jm.add_node(addTargetNode, nodeID, itemContent, itemInfo, direction)
            const newNode = this.jm.get_node(nodeID)
            this.setCurrentNameLabel(item, newNode.id)
            setTimeout(() => {
              if (!this.showNodeMenu) {
                this.jm.show(this.jm.get_data("node_tree"), dont_center)
                this.jm.view.relayout()
              }
            }, 200)
          }
          break;
        }
        case "delete": {
          let deleteTargetNode = this.jm.get_node(nodeID)
          this.setCurrentNameLabel(item, deleteTargetNode.id)
          if (deleteTargetNode != null) {
            this.jm.remove_node(deleteTargetNode)
          }
          break;
        }
        case "update": {
          let updateTargetNode = this.jm.get_node(nodeID)
          if (updateTargetNode != null) {
            this.jm.update_node(nodeID, itemContent, itemInfo)
            this.setCurrentNameLabel(item, updateTargetNode.id)
            setTimeout(() => {
              if (!this.showNodeMenu) {
                this.jm.show(this.jm.get_data("node_tree"), dont_center)
                this.jm.view.relayout()
              }
            }, 200)
          }
          break;
        }
        case "copy": {
          let copyTargetNode = this.jm.get_node(beforeNodeID)
          if (copyTargetNode != null) {
            this.jm.insert_node_after(copyTargetNode, nodeID, copyTargetNode.topic, itemInfo, copyTargetNode.direction)
            let copyNode = this.jm.get_node(nodeID)
            this.setCurrentNameLabel(item, copyNode.id)
            setTimeout(() => {
              if (!this.showNodeMenu) {
                this.jm.show(this.jm.get_data("node_tree"), dont_center)
              }
            }, 200)
          }
          break;
        }
        case "moveToBottom":
        case "moveToTop": {
          let moveTargetNode = this.jm.get_node(nodeID)
          let preNode = this.jm.get_node(beforeNodeID)
          let parentNode = this.jm.get_node(parentNodeID)
          if (moveTargetNode != null && preNode != null && parentNode != null) {
            this.jm.move_node(moveTargetNode, preNode.id, parentNode.id, moveTargetNode.direction)
            let afterMoveNode = actionItem.action == 'moveToBottom' ? this.jm.get_node(preNode.id) : this.jm.get_node(moveTargetNode.id)
            this.setCurrentNameLabel(item, afterMoveNode.id)
          }
          break;
        }
        case "moveToTarget": {
          let moveTargetNode = this.jm.get_node(nodeID)
          moveTargetNode.direction = direction
          let targetNode = this.jm.get_node(parentNodeID)
          if (moveTargetNode != null && targetNode != null) {
            this.jm.move_node(moveTargetNode, "_last_", targetNode.id, moveTargetNode.direction)
            let afterMoveNode = this.jm.get_node(moveTargetNode.id)
            this.setCurrentNameLabel(item, afterMoveNode.id)
          }
          break;
        }

      }
      this.jm.disable_edit() //關閉編輯
    },
    async convertImageToBase64(url) {
      // Check if already base64
      if (url.startsWith('data:image/')) {
        return url;
      }

      try {
        const response = await fetch(url);
        const blob = await response.blob();

        return new Promise((resolve) => {
          const img = new Image();
          img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);

            // Convert to JPEG base64 with quality 0.9
            const jpegBase64 = canvas.toDataURL('image/jpeg', 0.9);
            resolve(jpegBase64);
          };
          img.onerror = () => {
            console.error("Image loading failed");
            resolve(url); // Return original URL if loading fails
          };

          const objectUrl = URL.createObjectURL(blob);
          img.src = objectUrl;
        });
      } catch (error) {
        console.error("Image conversion failed", error);
        return url; // Return original URL if fetch fails
      }
    },

    async processMindMapData(data) {
      if (!data || !data.data) return;
      let that = this
      async function processNode(node) {

        // Check if topic contains an image and convert to base64 if needed
        const imgMatch = node.topic.match(/<img[^>]+src=["']([^"']+)["'][^>]*>/);
        if (imgMatch && !imgMatch[1].startsWith("data:image")) {
          const base64Image = await that.convertImageToBase64(imgMatch[1]);
          node.topic = node.topic.replace(
            /<img[^>]+src=["']([^"']+)["'][^>]*>/,
            `<img class='mindmap-img' src='${base64Image}'/>`
          );
        }

        // Process child nodes recursively
        if (node.children && Array.isArray(node.children)) {
          await Promise.all(node.children.map(processNode));
        }

        // Remove the specified fields 配合HT在isForLocalSave時，移除欄位
        if (that.hostSoftwareVersion) {
          const versionParts = that.hostSoftwareVersion.split('.'); // 按点拆分版號
          const majorMinor = parseFloat(`${versionParts[0]}.${versionParts[1]}`); // 提取主版本和次版本
          const patchVersion = parseInt(versionParts[3], 10); // 提取补丁版本（最后一部分）

          //5.3.0.0022版本以上, 移除nodeImg與nodeLink功能
          if (majorMinor > 5.3 || (majorMinor === 5.3 && patchVersion > 22) || parseFloat(versionParts[0]) >= 6) {
            console.log("hostSoftwareVersion:" + that.hostSoftwareVersion, "remove nodeImg ,nodeLink");
            delete node.nodeImg;
            delete node.nodeLink;
          }
        }
      }

      await processNode(data.data);

      return data;
    },
    replaceNodeImgUrl(node, latestSas) {
      if (node.nodeImg) {
        let newImgBlobLink = node.nodeImg.replace(/\?sv.*$/, "") + "?" + latestSas;
        node.nodeImg = newImgBlobLink;
        // 如果 topic 中包含 <img> 标签，替换其中的 src URL
        if (node.topic) {
          node.topic = node.topic.replace(/(<img[^>]+src=")[^"]+("[^>]*>)/, `$1${newImgBlobLink}$2`);
        }
      }

      // 递归遍历 children 节点
      if (node.children && node.children.length > 0) {
        node.children.forEach((childNode) => this.replaceNodeImgUrl(childNode, latestSas));
      }
    },

    async sendBackToHTWb(action, isForLocalSave = false) { //20250402 新增isForLocalSave 時 需將節點圖片轉換為base64
      let that = this
      let backData = ""

      if (isForLocalSave) {
        const processedData = await this.processMindMapData(this.jm.get_data("node_tree"))
        backData = JSON.stringify(processedData)
        console.log("isForLocalSaveData:", backData)
      } else {
        backData = JSON.stringify(this.jm.get_data("node_tree"))
      }

      console.log({
        item: backData,
        action: action,
        title: that.currentTitle
      })

      //傳送整份canvasJason
      if (window?.chrome?.webview) {
        window?.chrome?.webview.postMessage({
          item: backData,
          action: action,
          title: that.currentTitle
        })
      }
    },
    sendMDtoHTWb() {
      let jmNode = this.jm.get_data("node_tree")
      let mdText = md.jsMindToMd(jmNode, this)
      let that = this
      console.log({
        item: mdText,
        action: "MD.Push",
      });
      if (window?.chrome?.webview)
        window?.chrome?.webview.postMessage({
          item: mdText,
          action: "MD.Push",
          title: that.currentTitle
        });
    },
    sendSizeToHTWb() {
      let that = this
      setTimeout(() => {
        console.log({
          size: {
            width: window.innerWidth,
            height: window.innerHeight,
          },
          action: "sizeWb"
        })
        window?.chrome?.webview.postMessage({
          size: {
            width: window.innerWidth,
            height: window.innerHeight
          },
          action: "sizeWb",
          title: that.currentTitle
        });

      }, 0)
    },
    sendBase64toHTWb() {
      let that = this
      this.$q.loading.show()
      let jmDom = document.getElementById("jsmind_container");
      let jmnodesElement = document.querySelector("jmnodes")
      //先將Dom放大到跟繪圖區等大，再截圖

      jmDom.style.height = jmnodesElement.offsetHeight + "px"
      jmDom.style.width = jmnodesElement.offsetWidth + "px"
      this.jm.resize()

      setTimeout(() => {
        htmlToImage.toPng(jmDom).then(async dataURL => {
          if (window?.chrome?.webview)
            window?.chrome?.webview.postMessage({
              base64Image: dataURL,  //傳送整份base64
              action: "Snapshot.Push",
              title: that.currentTitle
            });
          jmDom.style.height = "100vh"
          jmDom.style.width = "100%"
          that.jm.resize()
          that.$q.loading.hide()
        })
      }, 200)

    },
    init_data() {
      this.jm = new jsMind(this.options);
      this.jm.show(this.mind);

      // 監聽節點展開/收合事件並同步（僅教師端 WebView 可發送）
      this.jm.add_event_listener((type, data) => {
        if (type === 1 && (data.evt === 'expand_node' || data.evt === 'collapse_node')) {
          const node = this.jm.get_node(data.node);
          // 只有在 WebView 環境（教師端）且非根節點時才發送協議
          if (node && !node.isroot && window?.chrome?.webview && !this.isTool) {
            const item = {
              nodeID: node.id,
              nodeContent: node.topic,
              expanded: node.expanded,
              ...node.data,
              fromInfo: this.fromInfo
            };
            this.sendItemToHTWb('update', item);
          }
        }
      });
    },
    initblob() {
      if (this.blobUrl != "") {
        this.blobServiceClient = new BlobServiceClient(
          this.blobUrl + "?" + this.blobSasWrite
        );
        this.containerClient = this.blobServiceClient.getContainerClient("");
        console.log(this.containerClient, "containerClient");
      }
    },

    zoomIn: function () {
      this.jm.view.zoomIn();
    },

    zoomOut: function () {
      this.jm.view.zoomOut();
    },
    viewBigImg() {
      this.showImgViewer = true
      this.showNodeMenu = false
    },
    viewNodeHistory() {
      const currentNode = this.jm.get_selected_node()
      // Parse JSON strings to objects
      const parsedHistory = this.currentHistoryForMenu.map(entry => JSON.parse(entry));

      // Filter out the objects with the specific nodeID
      const filteredHistory = parsedHistory.filter(entry => {
        const item = JSON.parse(entry.item);
        return item.nodeID === currentNode.id;
      });
      let parsedItems = []
      filteredHistory.forEach(item => {
        parsedItems.push({
          action: item.action,
          ...JSON.parse(item.item)
        })
      })
      this.currentNodeHistory = parsedItems
      this.showNodeHistory = true
      this.showNodeMenu = false
    },
    handleEdit(e) {
      if (this.jm.get_selected_node() !== null && !this.readOnlyMode && !this.isCurrentNodeLock) {
        this.isCurrentSelectRoot = this.jm.get_selected_node().isroot
        this.isCurrentNodeCanBeDelete = this.jm.get_selected_node().children.length == 0
        this.isCurrentNodeCanMoveUp = this.jm.find_node_before(this.jm.get_selected_node()) != null
        this.isCurrentNodeCanMoveDown = this.jm.find_node_after(this.jm.get_selected_node()) != null

        let tempDiv = document.createElement("div");
        tempDiv.innerHTML = this.jm.get_selected_node().topic;
        this.currentNodeHasImg = tempDiv.querySelector('img') != null

        if (this.currentNodeHasImg) {
          this.currentImgUrl = tempDiv.querySelector('img').src
        }

        this.nodeEditBy = this.jm.get_selected_node().data?.finalEditor ? this.jm.get_selected_node().data?.finalEditor : { seat: '', name: '' }
        this.openNode('edit')
        this.showNodeMenu = false
        this.showSelectedNote = false
        this.nodeTextNote = ""
      } else {
        this.showNodeMenu = false
        this.showSelectedNote = false
        this.nodeTextNote = ""
      }
    },
    setCurrentNameLabel(item, nodeId) {
      // 获取 jsmind-inner 容器
      const container = document.querySelector('.jsmind-inner');
      if (!container) return;

      // 获取节点位置
      const nodePos = this.getNodePos(nodeId);
      if (!nodePos) return;

      const nodeWidth = this.jm.get_node(nodeId)?._data.view.width || 0;

      // 计算 label 的坐标
      let nameLabelX = nodePos.left + nodeWidth - 10;
      let nameLabelY = nodePos.top;


      // 动态创建 nameLabel 元素
      let nameLabel = document.querySelector('.mindmap-name-label');
      if (!nameLabel) {
        nameLabel = document.createElement('div');
        nameLabel.className = 'mindmap-name-label';
        container.appendChild(nameLabel); // 插入到容器内
      }

      // 设置标签内容和样式
      nameLabel.textContent =
        item?.fromInfo.seat === 'wb'
          ? item?.fromInfo.name
          : `${item?.fromInfo.seat}\n${item?.fromInfo.name}`;

      nameLabel.style.position = 'absolute';
      nameLabel.style.left = `${nameLabelX}px`;
      nameLabel.style.top = `${nameLabelY}px`;
      nameLabel.style.display = 'block'; // 确保显示
      nameLabel.style.backgroundColor = 'black';
      nameLabel.style.whiteSpace = 'nowrap';
      nameLabel.style.color = 'white';
      nameLabel.style.fontSize = '14px';
      nameLabel.style.display = 'inline-block';
      nameLabel.style.zIndex = '1001';
      nameLabel.style.padding = '2px';
      nameLabel.style.fontWeight = 'bold';

      this.showNameLabel = true
    },

    handleNodeMenu(e) {
      if (this.jm.get_selected_node() !== null) {
        this.showNameLabel = false
        this.isCurrentSelectRoot = this.jm.get_selected_node().isroot
        this.isCurrentNodeLock = this.jm.get_selected_node().data?.lock
        this.isCurrentNodeCanBeDelete = this.jm.get_selected_node().children.length == 0
        this.isCurrentNodeCanMoveUp = this.jm.find_node_before(this.jm.get_selected_node()) != null
        this.isCurrentNodeCanMoveDown = this.jm.find_node_after(this.jm.get_selected_node()) != null
        this.isCurrentNodeCanMoveLeft = this.jm.get_selected_node().direction == -1 && this.jm.get_selected_node().parent.isroot;
        this.isCurrentNodeCanMoveRight = this.jm.get_selected_node().direction == 1 && this.jm.get_selected_node().parent.isroot;
        this.isCurrentNodeHasChildren = this.jm.get_selected_node().children.length > 0;
        let tempDiv = document.createElement("div");
        tempDiv.innerHTML = this.jm.get_selected_node().topic;
        this.currentNodeHasImg = tempDiv.querySelector('img') != null

        if (this.currentNodeHasImg) {
          this.currentImgUrl = tempDiv.querySelector('img').src
        }

        this.nodeEditBy = this.jm.get_selected_node().data?.finalEditor ? this.jm.get_selected_node().data?.finalEditor : { seat: '', name: '' }

        if (this.jm.get_selected_node().data?.note) {
          this.nodeTextNote = this.jm.get_selected_node().data?.note
          this.showSelectedNote = true
        } else {
          this.showSelectedNote = false
        }

        this.showNodeMenu = true
        let viewportHeight = window.innerHeight;
        // 距离底部的距离
        let distanceToBottom = viewportHeight - e.clientY;
        this.posX = e.clientX + 20

        if (distanceToBottom < 200) {
          if (viewportHeight > 500) {
            this.posY = e.clientY - 200;
          } else if (viewportHeight < 500) {
            this.posY = Math.floor((viewportHeight - 240) / 3);
          }
        } else {
          this.posY = e.clientY;
        }

      } else {
        this.showNodeMenu = false
        this.showSelectedNote = false
        this.nodeTextNote = ""
      }

    },
    confirm() {
      if (this.ctrlNodeMode == "add") {
        this.addNodeToSelectNode()
      } else if (this.ctrlNodeMode == "edit") {
        this.updateSelectNode()
      }
    },
    closeMoveTool() {
      this.showMoveTool = false
      this.showNodeMenu = false
      clearTimeout(this.drawLineTimeoutId);
      this.drawLineTimeoutId = null
    },
    confirmMoveToParent() {
      this.jm.enable_edit() //啟用編輯
      this.jm.move_node(this.currentNode, "_last_", this.currentMoveTargetNode.id)
      this.jm.disable_edit() //關閉編輯
      this.showMoveTool = false
      this.showNodeMenu = false
      clearTimeout(this.drawLineTimeoutId);
      this.drawLineTimeoutId = null
      if (!this.isTool) {
        let item = {
          parentNodeID: this.currentMoveTargetNode.id,
          nodeID: this.currentNode.id,
          fromInfo: this.fromInfo
        }
        this.sendItemToHTWb('moveToTarget', item)
      }
    },
    updateSelectNode() {
      // 獲取原始節點資料來比較變化
      const originalNode = this.jm.get_node(this.currentNode.id);
      
      let itemInfo = {
        fromInfo: this.fromInfo,
        finalAction: "update",
        note: this.nodeTextNote,
        lineColor: this.currentLineColor,
        'background-color': this.currentNodeColor, //按照jsMind套件中的命名
        nodeText: this.nodeText,
        nodeImg: "",
        nodeLink: "",
        lock: this.isCurrentNodeLock
      }
      
      let itemContent = `<p>${this.nodeText}</p>`
      let hasContentChange = false;
      
      // 檢查文字變化
      if (originalNode?.data?.nodeText !== this.nodeText) {
        hasContentChange = true;
      }
      
      if (this.currentImgUrl != '') {
        itemContent += `<img class='mindmap-img' src="${this.currentImgUrl}"/><br>`
        itemInfo.nodeImg = this.currentImgUrl
        if (originalNode?.data?.nodeImg !== this.currentImgUrl) {
          hasContentChange = true;
        }
      }
      
      if (this.nodeTextURL.trim() != '') {
        let url = this.fixURL(this.nodeTextURL)
        itemContent += `<a class="node-url" target="_blank" href="${url}">${this.jmNodeAttechIcon}</a>`
        itemInfo.nodeLink = url
        if (originalNode?.data?.nodeLink !== url) {
          hasContentChange = true;
        }
      }
      
      // 只有在圖片、文字、連結有變化時才設定 finalEditor
      if (hasContentChange) {
        itemInfo.finalEditor = this.fromInfo;
      }


      this.jm.enable_edit() //啟用編輯
      if (this.jm.get_node(this.currentNode.id)) {
        this.jm.update_node(this.currentNode.id, itemContent, itemInfo)
        let item = {
          nodeID: this.currentNode.id,
          nodeContent: itemContent,
          ...itemInfo
        }
        this.sendItemToHTWb('update', item)
      }
      else {
        this.iviewMessage.info(this.$t('webirs.mindmap.編輯失敗'))
      }

      this.jm.disable_edit() //關閉編輯
      this.showNodeMenu = false
      this.showAddNoteTool = false


      this.jm.select_clear() //清除選中狀態，避免白色字體殘留
    },
    openMoveTool() {
      this.showMoveTool = true
      this.currentNode = this.jm.get_selected_node();
      this.currentMoveTargetNode = this.currentNode.parent
      this.treeMenuData = this.jm.get_data("node_tree").data
      this.$q.loading.show()
      this.verticalLines = [];
      this.horizontalLines = [];
      this.drawLineTimeoutId = setTimeout(() => {
        const container = document.getElementById('movetool-scroll-area')
        if (container) {
          container.scrollTop = 0;   // 将滚动位置设置为顶部
          this.drawLineAreaH = container.scrollHeight;
          const targetNode = document.querySelector('.current-node-item').children[0]
          const targetNodeRect = targetNode.getBoundingClientRect();
          const containerRect = container.getBoundingClientRect();
          // Calculate the new left position
          const newLeft = (targetNodeRect.left - containerRect.left + targetNodeRect.width).toString() + 'px';

          // Get the element
          const hintElement = document.getElementById('show-hint');

          // Check if the element exists before setting the style
          console.log(hintElement);
          if (hintElement) {
            hintElement.style.left = newLeft;
            hintElement.style.transition = "0.5s ease-in-out";
          } else {
            console.error('Element with class "current-node-item-hint" not found.');
          }

        }
        this.drawLines();
        this.$q.loading.hide()
      }, 1000)

    },
    openNode(mode) {
      this.ctrlNodeMode = mode;
      this.showMoreSetting = false
      this.currentNode = this.jm.get_selected_node();
      if (this.currentNode) {
        if (mode === "add") {
          this.nodeText = "";
          this.currentImgUrl = '';
          this.nodeTextURL = "";
          this.nodeTextURLName = "";
          this.nodeTextNote = ""
          this.isCurrentSelectRoot = this.currentNode.isroot
          this.currentLineColor = this.currentNode.data?.lineColor
          this.currentNodeColor = this.currentNode.data?.['background-color']
        } else if (mode === "edit") {
          this.isCurrentNodePreEditByMe = this.currentNode.data?.fromInfo?.seat === this.fromInfo?.seat
          this.currentLineColor = this.currentNode.data?.lineColor
          this.currentNodeColor = this.currentNode.data?.['background-color']
          let tempDiv = document.createElement("div");
          tempDiv.innerHTML = this.currentNode.topic;
          let filteredString = tempDiv.querySelector('p').textContent;
          this.nodeText = filteredString;
          let imgElement = tempDiv.querySelector('img');
          // 獲取圖片的 src 屬性值
          this.currentImgUrl = imgElement ? imgElement.src : "";

          let urlElement = tempDiv.querySelector('a');
          this.nodeTextURL = urlElement ? urlElement.href : "";
          this.nodeTextURLName = urlElement ? urlElement.textContent : "";
          this.isCurrentSelectRoot = false
          this.nodeTextNote = this.currentNode?.data?.note || ''

        }
        this.showAddNoteTool = true;
        this.$nextTick(() => {
          document.getElementById("node-text-focus")?.focus()
          document.getElementById("node-text-focus-large")?.focus()
        }
        )
      } else {
        this.iviewMessage.info(this.$t('webirs.mindmap.請先選取節點'));
      }
    },
    fixURL(url) {
      // 使用正則表達式檢查URL是否以"http://"或"https://"開頭
      if (!/^https?:\/\//i.test(url)) {
        // 如果沒有，添加"http://"到URL的開頭
        url = "http://" + url;
      }
      return url;
    },
    addNodeToSelectNode() {
      this.jm.enable_edit() //啟用編輯
      let itemInfo = {
        finalEditor: this.fromInfo,
        fromInfo: this.fromInfo,
        finalAction: "add",
        note: this.nodeTextNote,
        lineColor: this.currentLineColor,
        'background-color': this.currentNodeColor, //按照jsMind套件中的命名
        nodeText: this.nodeText,
        nodeImg: "",
        nodeLink: "",
        lock: false,
      }

      let nodeID = this.genUUID()
      let itemContent = `<p>${this.nodeText}</p>`
      if (this.currentImgUrl != '') {
        itemContent += `<img class='mindmap-img' src="${this.currentImgUrl}"/><br>`
        itemInfo.nodeImg = this.currentImgUrl
      }

      if (this.nodeTextURL.trim() != '') {
        let url = this.fixURL(this.nodeTextURL)
        itemContent += `<a class="node-url" target="_blank" href="${url}">${this.jmNodeAttechIcon}</a>`
        itemInfo.nodeLink = url
      }
      if (this.jm.get_node(this.currentNode.id) != null) {
        this.jm.add_node(this.currentNode, nodeID, itemContent, itemInfo, this.direction)

        let item = {
          direction: this.direction,
          parentNodeID: this.currentNode.id,
          nodeID: nodeID,
          nodeContent: itemContent,
          ...itemInfo
        }
        this.sendItemToHTWb('add', item)
      } else {
        this.iviewMessage.info(this.$t('webirs.mindmap.新增失敗'))
      }
      this.jm.disable_edit() //關閉編輯
      this.showNodeMenu = false
      this.showAddNoteTool = false
      this.jm.select_clear() //清除選中狀態，避免白色字體殘留
    },
    deleteSelectNode() {
      //僅可刪除沒有子節點的節點
      this.jm.enable_edit() //啟用編輯

      this.currentNode = this.jm.get_selected_node()
      if (this.currentNode == null) {
        this.iviewMessage.info(this.$t('webirs.mindmap.請先選取節點'))
        return
      }
      if (this.currentNode.children.length == 0) {
        let item = {
          nodeID: this.currentNode.id,
          fromInfo: this.fromInfo
        }
        this.sendItemToHTWb('delete', item)
        this.jm.remove_node(this.currentNode)
      } else {
        this.iviewMessage.info(this.$t('webirs.mindmap.不可刪除有子項目的節點'))
      }

      this.jm.disable_edit() //關閉編輯
      this.showNodeMenu = false


    },
    genUUID() {
      let d = Date.now()
      //Performance.now() 亞毫秒級的時間戳記
      if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
        d += performance.now()
      }
      return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        //xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
        let r = (d + Math.random() * 16) % 16 | 0
        d = Math.floor(d / 16)
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
      })
    },
    moveNode(type) {
      this.jm.enable_edit() //啟用編輯

      this.currentNode = this.jm.get_selected_node()
      if (this.currentNode == null) {
        this.iviewMessage.info(this.$t('webirs.mindmap.請先選取節點'))
        return
      }
      if (type == "up") {
        let preNode = this.jm.find_node_before(this.currentNode)
        if (preNode == null) {
          this.iviewMessage.info(this.$t('webirs.mindmap.已是最上面'))
        }
        else {
          this.jm.move_node(this.currentNode, preNode.id, preNode.parent.id, this.currentNode.direction)
          let item = {
            direction: this.currentNode.direction,
            parentNodeID: preNode.parent.id,
            beforeNodeID: preNode.id,
            nodeID: this.currentNode.id,
            fromInfo: this.fromInfo
          }
          this.sendItemToHTWb('moveToTop', item,)
        }
      } else if (type == "down") {
        let nextNode = this.jm.find_node_after(this.currentNode)
        if (nextNode == null) {
          this.iviewMessage.info(this.$t('webirs.mindmap.已是最下面'))
        }
        else {
          this.jm.move_node(nextNode, this.currentNode.id, this.currentNode.parent.id, nextNode.direction)

          let item = {
            direction: nextNode.direction,
            parentNodeID: this.currentNode.parent.id,
            beforeNodeID: this.currentNode.id,
            nodeID: nextNode.id,
            fromInfo: this.fromInfo
          }
          this.sendItemToHTWb('moveToBottom', item,)
        }
      }
      else if (type == "left" || type == "right") {
        this.currentNode.direction = type == "left" ? -1 : 1;
        this.jm.move_node(this.currentNode, "_last_", this.currentNode.parent.id, this.currentNode.direction);

        let item = {
          direction: this.currentNode.direction,
          parentNodeID: this.currentNode.parent.id,
          nodeID: this.currentNode.id,
          fromInfo: this.fromInfo,
        };
        this.sendItemToHTWb("moveToTarget", item);
      }

      this.jm.disable_edit() //關閉編輯
      this.showNodeMenu = false
    },
    sendItemToHTWb(action, item) {
      let that = this
      console.log({
        item: JSON.stringify(item),
        action: action,
        actionType: action,
        title: that.currentTitle,
      });

      if (window?.chrome?.webview)
        window?.chrome?.webview.postMessage({
          item: JSON.stringify(item),
          action: action,
          actionType: action, //先跟action 一樣
          title: that.currentTitle,
          from: 'wb',
          uuid: item.nodeID
        });
    },
    pauseReplay() {
      this.isPauseReplay = true
      clearTimeout(this.replayTimeoutId);
      this.replayTimeoutId = null;
    },
    continueReplay() {
      this.isPauseReplay = false
      this.replayAction(this.currentReplayIndex + 1);
    },
    replayAction(index) {
      let that = this
      this.currentReplayIndex = index
      if (index < this.currentReplayHistory.length) {
        let item = this.currentReplayHistory[index];
        this.updateStageNode(JSON.parse(item));
        this.replayTimeoutId = setTimeout(() => {
          that.replayAction(index + 1);
        }, 800 / (that.replayFastMode ? 4 : 1));

      } else {
        this.isCoworkReplay = false
        this.showNameLabel = false
        this.sendReplayDonetoHTWb()
      }
    },
    sendReplayDonetoHTWb() {
      let that = this
      console.log({
        action: "ReplayDone",
        title: that.currentTitle
      });
      if (window?.chrome?.webview)
        window?.chrome?.webview.postMessage({
          action: "ReplayDone",
          title: that.currentTitle
        });
    },
    closeAllToolBox() { //重整時關閉所有編輯視窗
      this.showAddNoteTool = false
      this.showNodeMenu = false
    },
    calScaleRatio(imgTargetWidth, imgTargetHeight, bgWidth, bgHeight) {
      let ratio = 0
      if (imgTargetWidth > bgWidth && imgTargetHeight < bgHeight) {
        ratio = bgWidth / imgTargetWidth
      } else if (imgTargetWidth < bgWidth && imgTargetHeight > bgHeight) {
        ratio = bgHeight / imgTargetHeight
      } else if (imgTargetWidth < bgWidth && imgTargetHeight < bgHeight) {
        ratio = bgWidth / imgTargetWidth < bgHeight / imgTargetHeight ? bgWidth / imgTargetWidth : bgHeight / imgTargetHeight
      } else {
        //1.判斷要縮哪一邊
        let imgWidthMinusCanvasWidth = imgTargetWidth - bgWidth
        let imgHeightMinusCanvasHeight = imgTargetHeight - bgHeight
        //console.log(imgWidthMinusCanvasWidth,imgHeightMinusCanvasHeight)
        if (imgWidthMinusCanvasWidth > imgHeightMinusCanvasHeight) ratio = bgWidth / imgTargetWidth
        else {
          ratio = bgHeight / imgTargetHeight
        }
      }
      let screenOffsetX = (imgTargetWidth * ratio - bgWidth) / 2 //整體置中與白邊的左右差距
      let screenOffsetY = (imgTargetHeight * ratio - bgHeight) / 2 //整體置中與白邊的上下差距

      let output = {
        ratio: ratio,
        screenOffsetX: screenOffsetX,
        screenOffsetY: screenOffsetY
      }

      return output
    },
    dataURLtoFile(dataurl, filename) {
      const arr = dataurl.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    drawLines() {
      const items = this.$el.querySelectorAll(".tree-menu-item");
      const container = document.getElementById('movetool-scroll-area');
      const containerBox = container.getBoundingClientRect();

      items.forEach((item, index) => {
        const rect = item.getBoundingClientRect(); // 當前項目的矩形
        const parent = item.closest(".tree-menu-item-wrap"); // 找到最近的父節點

        if (!parent || !container) return;

        const parentRect = parent.getBoundingClientRect(); // 父節點的矩形
        const parentRelativeY = parentRect.top - containerBox.top; // 父節點相對於容器的Y位置
        const childRelativeY = rect.top - containerBox.top; // 當前項目相對於容器的Y位置

        // 獲取縮排距離
        const childStyle = window.getComputedStyle(item);
        let paddingLeftValue = parseInt(childStyle.paddingLeft) || 0;
        let startY = parentRelativeY; // 垂直線的起始Y座標
        let isLastChild = false; // 用於標記是否為最後一個子元素

        // 計算下一個項目的縮排距離
        let nextPaddingLeftValue = 0;
        if (items[index + 1]) {
          const nextItem = window.getComputedStyle(items[index + 1]);
          const nextItemTreeMenu = items[index + 1].closest(".tree-menu");
          if (nextItemTreeMenu.style?.display === "none") {
            nextPaddingLeftValue = paddingLeftValue;
          } else {
            nextPaddingLeftValue = parseInt(nextItem.paddingLeft) || 0;
          }
        }

        // 確定垂直線的起始Y座標
        const itemId = item.closest(".tree-menu").id;
        const nodeBefore = this.jm.find_node_before(itemId.slice(4));
        const nodeAfter = this.jm.find_node_after(itemId.slice(4));

        if (nodeBefore) {
          startY = document.getElementById(`mid-` + nodeBefore.id).getBoundingClientRect().top - containerBox.top;
        }

        isLastChild = !nodeAfter; // 檢查是否是最後一個子元素

        // 處理特殊情況：第1層項目或沒有前驅節點的項目
        if (paddingLeftValue == 30) {
          let notFirstChildId = this.treeMenuData.children.findIndex(i => i.id == itemId.slice(4));
          if (notFirstChildId > 0 && !nodeBefore) {
            let nodeInArrBeforeId = this.treeMenuData.children[notFirstChildId - 1].id;
            startY = document.getElementById(`mid-` + nodeInArrBeforeId).getBoundingClientRect().top - containerBox.top + rect.height / 2;
          }
        }
        if (!nodeBefore) {
          const nodeParent = this.jm.get_node(itemId.slice(4))?.parent;
          if (nodeParent !== undefined && startY >= 0) {
            startY = document.getElementById(`mid-` + nodeParent.id).getBoundingClientRect().top - containerBox.top + rect.height / 2 - 10;
          }
        }

        // 畫垂直線和水平線
        if (paddingLeftValue != 0) {
          // 垂直線: 父節點中心到底部的線
          this.verticalLines.push({
            x1: paddingLeftValue + 35,
            y1: startY,
            y2: isLastChild ? parentRelativeY + rect.height / 2 : parentRelativeY + rect.height,
            x2: paddingLeftValue + 35
          });

          // 水平線: 連接到子節點的水平線
          this.horizontalLines.push({
            x1: paddingLeftValue + 35,
            y1: childRelativeY + rect.height / 2,
            x2: paddingLeftValue + 55,
            y2: childRelativeY + rect.height / 2
          });
        }
      });
    },
    async loadPhoneticFont() {
      if (this.fontLoaded) return true;

      try {
        this.fontLoading = true;

        // 顯示全屏 Loading
        this.$q.loading.show({
          message: this.$t('mindmap.phoneticFont.loading'),
          spinnerColor: 'primary'
        });

        console.log('開始載入注音字體...');

        // 使用 Font Loading API 動態載入字體
        const fontUrl = require('../assets/fonts/BpmfZihiKaiStd-Regular.ttf');
        const font = new FontFace(
          'BpmfZihiKaiStd',
          `url(${fontUrl})`
        );

        await font.load();
        document.fonts.add(font);

        this.fontLoaded = true;
        console.log('注音字體載入成功！');
        return true;
      } catch (error) {
        console.error('注音字體載入失敗:', error);
        return false;
      } finally {
        this.fontLoading = false;
        // 隱藏 Loading
        this.$q.loading.hide();
      }
    },

    toggleReplayMode() {
      this.replayFastMode = !this.replayFastMode;
    },

  },
};
</script>
<style lang="less">
@import '../assets/color.less';

#mindmap-img-editor {
  margin: 0 !important;

  .canvas-qcard {
    top: 0 !important;
  }

  .q-dialog__inner--minimized>div {
    max-width: none !important;
    max-height: none !important;
  }

  .q-dialog__inner {
    padding: 0 !important;
  }
}

.showPhonetic {
  * {
    font-family: 'BpmfZihiKaiStd', sans-serif !important;
  }
}
.mindmap-htwb {
  @import '../assets/color.less';

  .select-btn {
    &:focus {
      --tw-ring-color: @light-color !important;
    }

    .arrow-icon-up {
      color: @light-color !important;
    }
  }

  jmnode {
    max-width: 150px;
    font-size: 0;

    p {
      white-space: normal;
      word-break: keep-all;
      word-wrap: break-word;
      overflow-wrap: break-word;
      font-size: 16px !important;
    }

    text-align: center !important;

    .node-url {
      cursor: pointer;
      display: flex;
      align-items: center;
      /* 水平居中对齐 */
      justify-content: center;

      /* 垂直居中对齐 */
      .node-url-icon {
        margin-top: 5px;

        path {
          fill: blue !important;
        }
      }

      &:hover {
        .node-url-icon {
          path {
            fill: rgb(255, 255, 255) !important;
          }
        }
      }
    }

    .mindmap-img {
      margin: 5px 0px;
    }

    .myNoteName {
      font-size: 40px;
    }
  }

  .node-history-wrap {
    position: absolute;
    display: block;
    width: 100%;
    background-color: @editbtn-shadow;
    transition: 0.5s;
    color: black;
    height: 100%;
    z-index: 1003;

    .node-history-title {
      font-size: 18px;
      color: #3d3d3d;
      margin-bottom: 0px;
      margin: 10px;
    }

    .node-history-scroll-area {
      height: 75vh;
      overflow: auto;
      padding: 10px;

      .node-history-table {
        width: 100%;
        border-collapse: collapse;

        tr,
        thead {
          border-bottom: 1px solid @text-color;
        }

        thead {
          th {
            font-weight: bolder !important;
          }
        }

        th,
        td {
          padding: 10px;

          .color-line {
            width: 30px;
            height: 2px;
            position: relative;
            left: 50%;
            transform: translate(-50%, 0);
          }

          .color-ball {
            width: 15px;
            height: 15px;
            border-radius: 50%;
            position: relative;
            left: 50%;
            transform: translate(-50%, 0);
          }
        }

        th {
          background-color: #f2f2f2;
          text-align: center;
          position: sticky;
          top: 0;
          /* Sticky to the top of the container */
          z-index: 1;
          /* Ensure the header stays on top */
        }

        th:first-child {
          left: 0;
          z-index: 2;
        }

        td:first-child {
          left: 0;
          position: sticky;
          z-index: 1;
        }

        td {
          max-width: 150px;
          text-align: center;

          img {
            width: 100px !important;
          }

        }
      }
    }

    .close-btn {
      position: absolute;
      top: -10px;
      right: -10px;
      width: 30px;
      height: 30px;
      line-height: 30px;
      background-color: @darken-gray;
      text-align: center;
      border-radius: 50%;
      cursor: pointer;
      z-index: 100;

      .close-icon {
        font-size: 16px;
      }
    }

    .node-history-card {
      top: 10%;
      width: 50%;
      min-height: 350px;
      transition: 0.5s;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      background-color: @nomal-bgc;
      font-weight: bolder;
      padding: 10px 0px 0px 20px;
      border-radius: 5px;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
      z-index: 102;
      text-align: center;
    }
  }
}
</style>

<style lang="less" scoped>
@import '../assets/HTwbMindCSS/mindmap.less';
</style>